var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.08,127.14s-50.21,48.45-42.4,140,80.79,130.64,132.23,117,65-43,107.28-57.24,119.06,3.62,162.37-51.62S451.6,119.89,393,54.6,170.29,14.89,91.08,127.14Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.08,127.14s-50.21,48.45-42.4,140,80.79,130.64,132.23,117,65-43,107.28-57.24,119.06,3.62,162.37-51.62S451.6,119.89,393,54.6,170.29,14.89,91.08,127.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.25,448.23h-15.8a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h15.8a.5.5,0,0,1,.5.5A.5.5,0,0,1,454.25,448.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.89,448.23H25.78a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H429.89a.5.5,0,0,1,.5.5A.5.5,0,0,1,429.89,448.23Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.45,359.21c2.09.91,7.2.79,7.21.79s-1.1-3.34-1.2-3.54c-1.12-2.35-4.67-6.22-7.55-5.83a3.45,3.45,0,0,0-2.77,4.32C329.62,356.94,331.67,358.43,333.45,359.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.22,374c2.16.32,6.73-1,7.09-1.11a61.16,61.16,0,0,0,2.76,7.65c.63,1.45,1.31,2.9,2,4.34-.42-.61-.8-1.16-.86-1.23-1.7-2-6.14-4.76-8.82-3.62a3.44,3.44,0,0,0-1.53,4.89c1,1.8,3.36,2.69,5.28,3s5.86-.76,6.9-1l.81,1.65c1.32,2.63,2.65,5.24,3.88,7.85.43.92.82,1.84,1.22,2.76-.37-.54-.69-1-.75-1.06-1.7-2-6.14-4.76-8.82-3.62a3.44,3.44,0,0,0-1.53,4.89c1,1.8,3.36,2.69,5.29,3s5.48-.66,6.7-1c.38.95.76,1.91,1.08,2.85.21.65.45,1.26.62,1.92l.54,1.94c.3,1.24.61,2.52.87,3.74.19.85.35,1.66.52,2.48-.42-.92-1.28-2.7-1.37-2.84-1.38-2.21-5.35-5.64-8.17-4.93a3.45,3.45,0,0,0-2.25,4.61c.71,1.93,2.91,3.17,4.77,3.74,2,.62,6.57.05,7.14,0,.27,1.35.52,2.67.74,3.92.11.66.21,1.28.32,1.9h1.8l-.43-2.22c-.27-1.37-.58-2.84-.92-4.34a35.44,35.44,0,0,0,4-1.87c1.49,1.61,5.31,3.5,5.8,3.74-.52,1.28-1,2.52-1.54,3.68l-.45,1h1.89l.15-.34c.53-1.3,1.07-2.69,1.62-4.13.55.12,5,1,7.12.56,1.89-.43,4.18-1.5,5-3.38a3.44,3.44,0,0,0-1.9-4.76c-2.76-.93-7,2.21-8.52,4.3-.09.12-.93,1.57-1.44,2.5.22-.59.44-1.16.66-1.77.44-1.2.84-2.41,1.28-3.71.19-.64.39-1.28.58-1.93s.34-1.34.52-2c.37-1.57.68-3.19.95-4.82,1.05.38,4.81,1.69,6.75,1.55s4.37-.85,5.49-2.57a3.45,3.45,0,0,0-1.16-5c-2.59-1.33-7.22,1.13-9.07,3-.11.11-1.29,1.57-1.92,2.39.16-1,.32-2,.44-3,.36-2.89.63-5.82.92-8.75.08-.9.18-1.79.28-2.68.37.14,4.8,1.79,7,1.64,1.94-.14,4.37-.85,5.49-2.57a3.44,3.44,0,0,0-1.16-5c-2.59-1.33-7.23,1.13-9.07,3-.14.14-1.82,2.25-2.23,2.81.21-2,.44-3.93.74-5.85a62,62,0,0,1,1.67-7.69c.18.07,4.8,1.81,7,1.65,1.94-.13,4.37-.84,5.49-2.57a3.45,3.45,0,0,0-1.16-5c-2.59-1.34-7.23,1.12-9.07,3-.15.14-2,2.41-2.26,2.85,0-.15.07-.3.12-.45a44.78,44.78,0,0,1,3-7.28c.67-1.29,1.37-2.49,2.08-3.65.83.42,4.63,2.26,6.65,2.34s4.44-.36,5.74-1.95a3.44,3.44,0,0,0-.6-5.09c-2.43-1.61-7.31.32-9.34,1.94-.11.09-1.13,1.11-1.87,1.87.33-.52.66-1.06,1-1.55,1.22-1.83,2.45-3.43,3.55-4.85.63-.8,1.22-1.5,1.78-2.16,1,0,5.14-.15,6.94-1s3.77-2.37,4.19-4.38a3.44,3.44,0,0,0-2.88-4.24c-2.89-.31-6.33,3.66-7.39,6-.09.21-1.15,3.58-1.1,3.58H392c-.55.62-1.13,1.3-1.75,2-1.13,1.4-2.4,3-3.66,4.79a62,62,0,0,0-3.79,6.05,45,45,0,0,0-3.25,7.3s0,.06,0,.09c0-.85,0-3.24-.05-3.42-.33-2.58-2.5-7.36-5.36-7.89a3.44,3.44,0,0,0-4,3.24c-.17,2.05,1.31,4.1,2.76,5.39,1.64,1.46,6.17,2.87,6.53,3a59.94,59.94,0,0,0-1.91,7.9c-.28,1.56-.51,3.14-.73,4.72,0-.73,0-1.39,0-1.48-.34-2.58-2.5-7.37-5.36-7.9a3.45,3.45,0,0,0-4,3.24c-.16,2,1.32,4.1,2.77,5.4s5.31,2.59,6.33,2.92c-.07.6-.16,1.21-.23,1.82-.35,2.92-.68,5.84-1.1,8.69-.15,1-.33,2-.51,3,0-.66,0-1.21,0-1.29-.34-2.58-2.5-7.37-5.36-7.9a3.45,3.45,0,0,0-4,3.24c-.17,2.05,1.31,4.1,2.76,5.4s4.94,2.46,6.15,2.86c-.21,1-.42,2-.67,3-.19.65-.32,1.29-.55,1.94s-.41,1.28-.62,1.92c-.43,1.2-.88,2.44-1.33,3.6-.31.81-.63,1.58-.94,2.35.16-1,.43-3,.43-3.12a13.36,13.36,0,0,0-1.79-6.51,4.77,4.77,0,0,0-.05-.76,3.45,3.45,0,0,0-4.21-2.93c-2.82.75-4.6,5.69-4.73,8.29,0,.15.09,1.82.17,2.88-.14-.62-.27-1.21-.43-1.84-.29-1.24-.62-2.48-1-3.81-.2-.63-.39-1.27-.59-1.92s-.45-1.31-.68-2c-.55-1.52-1.19-3-1.87-4.55,1.09-.26,4.95-1.24,6.49-2.43s3.18-3.12,3.16-5.17a3.45,3.45,0,0,0-3.72-3.53c-2.89.32-5.41,4.93-5.93,7.47,0,.16-.2,2-.28,3.06-.41-.9-.82-1.81-1.27-2.71-1.29-2.61-2.68-5.21-4.06-7.8-.42-.8-.83-1.6-1.25-2.39.39-.09,5-1.16,6.73-2.49,1.54-1.18,3.18-3.12,3.16-5.17a3.44,3.44,0,0,0-3.72-3.53c-2.89.32-5.41,4.93-5.93,7.47,0,.19-.28,2.89-.31,3.57-.91-1.75-1.81-3.51-2.62-5.28a60.9,60.9,0,0,1-2.84-7.34c.18,0,5-1.13,6.77-2.49,1.54-1.19,3.18-3.12,3.16-5.18a3.43,3.43,0,0,0-3.72-3.52c-2.89.31-5.41,4.92-5.93,7.47,0,.2-.3,3.09-.31,3.62,0-.14-.11-.29-.15-.44a44.53,44.53,0,0,1-1.48-7.75c-.16-1.44-.23-2.83-.27-4.19.91-.11,5.1-.67,6.83-1.72s3.5-2.75,3.71-4.79a3.44,3.44,0,0,0-3.31-3.91c-2.91,0-5.92,4.3-6.72,6.77,0,.14-.33,1.55-.53,2.59,0-.62,0-1.25,0-1.83,0-2.21.14-4.22.28-6,.09-1,.19-1.93.29-2.78.84-.58,4.21-3,5.24-4.66s1.84-4.05,1.09-6a3.46,3.46,0,0,0-4.75-1.95c-2.58,1.34-3.26,6.55-2.84,9.11,0,.22,1,3.62,1.06,3.59l.05,0c-.11.82-.22,1.7-.33,2.67-.17,1.78-.36,3.8-.41,6a60.21,60.21,0,0,0,.17,7.14,45.66,45.66,0,0,0,1.32,7.88.32.32,0,0,1,0,.09c-.45-.72-1.8-2.69-1.92-2.83-1.7-2-6.15-4.76-8.83-3.63a3.45,3.45,0,0,0-1.52,4.9C330.93,372.84,333.3,373.73,335.22,374Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.15,360.33s.93-3.4,1-3.62c.36-2.57-.47-7.76-3.09-9a3.45,3.45,0,0,0-4.69,2.08c-.7,1.93.19,4.3,1.25,5.93C380.82,357.61,385.14,360.33,385.15,360.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,418.93h37.93a0,0,0,0,1,0,0v20.43a17,17,0,0,1-17,17h-3.89a17,17,0,0,1-17-17V418.93A0,0,0,0,1,346.27,418.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.18,456.88h-3.9a17.54,17.54,0,0,1-17.51-17.52V418.43h38.92v20.93A17.53,17.53,0,0,1,367.18,456.88Zm-20.41-37.45v19.93a16.54,16.54,0,0,0,16.51,16.52h3.9a16.54,16.54,0,0,0,16.51-16.52V419.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.19,438v-4.61c-3,2.37-6.93,1.84-9.79,0-5.21-3.28-11.27-.71-11.53-.6a2,2,0,1,0,1.59,3.67c.05,0,4.42-1.82,7.8.32a13.6,13.6,0,0,0,7.23,2.18A11.75,11.75,0,0,0,384.19,438Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.49,439.49a14.11,14.11,0,0,1-7.5-2.26c-3.16-2-7.28-.3-7.33-.28a2.5,2.5,0,0,1-2-4.59c.27-.11,6.57-2.78,12,.64,2.36,1.49,6.19,2.38,9.23,0l.8-.64v6l-.29.13A12.13,12.13,0,0,1,379.49,439.49Zm-11.14-4.23a7.81,7.81,0,0,1,4.18,1.12,12.2,12.2,0,0,0,11.16,1.28v-3.32c-3.28,2-7.13,1-9.56-.49-5-3.14-10.82-.68-11.06-.57a1.5,1.5,0,1,0,1.2,2.75A11.49,11.49,0,0,1,368.35,435.26ZM384.19,438h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,437.39a29.61,29.61,0,0,0,8.37-2.77c6.64-3.2,18.19-7.77,20.81-2.52a2,2,0,0,0,3.58-1.79c-3.17-6.34-12-6.11-26.12.7a26.33,26.33,0,0,1-6.64,2.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.77,438v-5.05l.41-.08a26.28,26.28,0,0,0,6.51-2.28c14.45-6.95,23.47-7.11,26.79-.47a2.5,2.5,0,0,1-4.48,2.23c-2.52-5.05-14.93.24-20.14,2.75a30.47,30.47,0,0,1-8.52,2.82Zm1-4.23v3.07a30.87,30.87,0,0,0,7.65-2.64c8.32-4,18.8-7.65,21.48-2.29a1.5,1.5,0,1,0,2.68-1.35c-3-6-11.59-5.74-25.45.93A28.37,28.37,0,0,1,346.77,433.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.24,
    cy: 428.09,
    r: 1.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.24,430a1.91,1.91,0,1,1,1.91-1.91A1.91,1.91,0,0,1,351.24,430Zm0-2.82a.91.91,0,1,0,.91.91A.91.91,0,0,0,351.24,427.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.75,425.28a1.41,1.41,0,1,1-1.4-1.41A1.4,1.4,0,0,1,360.75,425.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.34,427.18a1.91,1.91,0,1,1,1.91-1.9A1.9,1.9,0,0,1,359.34,427.18Zm0-2.81a.91.91,0,1,0,.91.91A.9.9,0,0,0,359.34,424.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.27,423.16a1.41,1.41,0,1,1-1.41-1.41A1.41,1.41,0,0,1,370.27,423.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.86,425.07a1.91,1.91,0,1,1,1.9-1.91A1.91,1.91,0,0,1,368.86,425.07Zm0-2.82a.91.91,0,1,0,.9.91A.91.91,0,0,0,368.86,422.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.6,424.39a1.41,1.41,0,1,1-1.41-1.4A1.41,1.41,0,0,1,379.6,424.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.19,426.3a1.91,1.91,0,1,1,1.91-1.91A1.91,1.91,0,0,1,378.19,426.3Zm0-2.81a.91.91,0,1,0,.91.9A.9.9,0,0,0,378.19,423.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.57,
    cy: 439.19,
    r: 1.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.57,441.1a1.91,1.91,0,1,1,1.91-1.91A1.91,1.91,0,0,1,366.57,441.1Zm0-2.82a.91.91,0,1,0,.91.91A.91.91,0,0,0,366.57,438.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,442a1.41,1.41,0,1,1-1.41-1.41A1.41,1.41,0,0,1,375,442Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.61,443.92a1.91,1.91,0,1,1,1.91-1.91A1.92,1.92,0,0,1,373.61,443.92Zm0-2.82a.91.91,0,1,0,.91.91A.91.91,0,0,0,373.61,441.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.07,442a1.41,1.41,0,1,1-1.41-1.41A1.41,1.41,0,0,1,382.07,442Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.66,443.92a1.91,1.91,0,1,1,1.91-1.91A1.91,1.91,0,0,1,380.66,443.92Zm0-2.82a.91.91,0,1,0,.91.91A.91.91,0,0,0,380.66,441.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.07,41.48a42.37,42.37,0,0,0-14.73,7.85,26.78,26.78,0,0,0-5.51,6.39,19.63,19.63,0,0,0-2.8,8l-.13,2.15.15,2.14a17,17,0,0,0,.32,2.12c.18.69.31,1.39.53,2.07A40.39,40.39,0,0,0,116.27,80c2.67,5,5.94,9.48,8,14.5a27,27,0,0,1,2.21,7.7,14.28,14.28,0,0,1-1.07,7.59,17.28,17.28,0,0,1-4.87,6,44.86,44.86,0,0,1-6.77,4.48c-4.78,2.7-9.87,5-14.69,8a41.27,41.27,0,0,0-6.84,5.26,23,23,0,0,0-5.11,7.22,20.46,20.46,0,0,0-1.78,8.78A18.35,18.35,0,0,0,88,158.32a31,31,0,0,0,5.68,6.75c2.12,2,4.37,3.7,6.55,5.4a24.81,24.81,0,0,1,5.42,5.46c1.33,2,2,4.25,1.37,6.25s-2.28,3.91-4.29,5.44a32.83,32.83,0,0,1-3.27,2.13l-3.64,2.06a65.86,65.86,0,0,0-7.17,4.7,26.4,26.4,0,0,0-6.14,6.41,18.77,18.77,0,0,0-3,8.51,16.78,16.78,0,0,0-.09,2.24,17.14,17.14,0,0,0,.11,2.17c.15,1.42.23,2.84.51,4.24a58.76,58.76,0,0,0,5,16.19,61.49,61.49,0,0,0,4.2,7.31,44.88,44.88,0,0,0,5.26,6.56.19.19,0,0,0,.25,0,.19.19,0,0,0,0-.27h0a60.32,60.32,0,0,1-12.11-30.14c-.19-1.34-.19-2.71-.26-4.06l0-1c0-.34,0-.65,0-1a13.68,13.68,0,0,1,.15-1.92,15.58,15.58,0,0,1,2.73-7c2.93-4.17,7.62-7,12.4-9.67l3.63-2a34.59,34.59,0,0,0,3.73-2.39,20.3,20.3,0,0,0,3.4-3.12,8.7,8.7,0,0,0,.72-1,12.22,12.22,0,0,0,.68-1,11,11,0,0,0,1-2.34,9.64,9.64,0,0,0,.4-2.57,11.2,11.2,0,0,0-.1-1.3l-.07-.64-.16-.61c-.12-.4-.22-.82-.35-1.21l-.5-1.12a7,7,0,0,0-.57-1.05l-.62-1a28.58,28.58,0,0,0-6.34-6.28c-2.24-1.67-4.42-3.29-6.43-5.07a27.62,27.62,0,0,1-5.17-5.84,15.06,15.06,0,0,1-2.25-7.07A17.33,17.33,0,0,1,90,142c2-4.76,6.11-8.41,10.64-11.35s9.58-5.38,14.44-8.22a48.38,48.38,0,0,0,7-4.85,19.38,19.38,0,0,0,5.37-6.94,16.45,16.45,0,0,0,1.11-8.72,29.54,29.54,0,0,0-2.5-8.23c-2.34-5.22-5.74-9.69-8.46-14.47a38.86,38.86,0,0,1-3.42-7.42c-.23-.64-.37-1.31-.56-2a16.88,16.88,0,0,1-.34-2l-.19-2,.07-2a18.85,18.85,0,0,1,2.49-7.65,25.89,25.89,0,0,1,5.19-6.3,41.66,41.66,0,0,1,14.35-8,.2.2,0,0,0,.12-.24A.2.2,0,0,0,135.07,41.48Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.36,277.32h0c-.76.3-1.52.64-2.29.91a17.91,17.91,0,0,1-2.36.64,13.09,13.09,0,0,1-4.79.18,25.57,25.57,0,0,1-4.71-1.18l-4.74-1.56a67.05,67.05,0,0,0-9.83-2.27c-1.66-.3-3.33-.44-5-.65a14.06,14.06,0,0,0-5.41.47,13.36,13.36,0,0,0-4.83,2.62,19.77,19.77,0,0,0-3.57,4,48.89,48.89,0,0,0-4.71,9.14c-1.31,3.09-2.39,6.22-3.85,9a47.14,47.14,0,0,1-5.07,8.13,37.25,37.25,0,0,1-6.58,6.75,24.64,24.64,0,0,1-8.13,4.28,22.28,22.28,0,0,1-9,.78l-2.27-.37-2.23-.63a33.58,33.58,0,0,1-4.42-1.71c-5.84-2.66-11.27-6.53-17.42-9.54a41.79,41.79,0,0,0-9.74-3.46,22.56,22.56,0,0,0-15.56,1.82,30.63,30.63,0,0,0-4.42,2.81,53.19,53.19,0,0,0-7.35,7.1c-1.11,1.27-2.18,2.54-3.25,3.82l-1.59,1.9-1.64,1.8a44.14,44.14,0,0,1-3.43,3.41c-.58.57-1.25,1-1.87,1.51a16.55,16.55,0,0,1-1.95,1.4,23,23,0,0,1-8.68,3.63,23.6,23.6,0,0,1-9.43-.2,39.15,39.15,0,0,1-9.12-3.26c-2.94-1.42-5.8-3.05-8.62-4.76-5.65-3.44-11.18-7.15-17.05-10.36a69.89,69.89,0,0,0-9.12-4.23,38.75,38.75,0,0,0-9.8-2.36,31.76,31.76,0,0,0-10.06.55,40.26,40.26,0,0,0-9.48,3.31,41.84,41.84,0,0,0-8.36,5.51,39.63,39.63,0,0,0-6.7,7.41.19.19,0,0,0,0,.26.2.2,0,0,0,.27,0,39.06,39.06,0,0,1,6.76-7.19,41.11,41.11,0,0,1,8.33-5.27,35,35,0,0,1,19.07-3.4,37.07,37.07,0,0,1,9.46,2.47,69.49,69.49,0,0,1,8.85,4.31c5.72,3.27,11.15,7.07,16.78,10.65,2.83,1.77,5.72,3.48,8.73,5a41.58,41.58,0,0,0,9.54,3.56,25.84,25.84,0,0,0,10.33.35,25.4,25.4,0,0,0,9.61-3.84,18.16,18.16,0,0,0,2.11-1.48c.67-.53,1.41-1,2-1.58a47.58,47.58,0,0,0,3.69-3.55l1.73-1.86,1.63-1.89c1.09-1.26,2.16-2.5,3.26-3.72a51,51,0,0,1,7-6.62,28.17,28.17,0,0,1,4-2.47,22.05,22.05,0,0,1,4.35-1.53,21.5,21.5,0,0,1,9.2.21,38.53,38.53,0,0,1,8.91,3.36c5.74,2.92,11.12,6.91,17.33,9.89a35.41,35.41,0,0,0,4.84,1.94l2.55.75,2.63.46a25.35,25.35,0,0,0,10.67-.85,28.46,28.46,0,0,0,9.36-5,41,41,0,0,0,7.22-7.51,51,51,0,0,0,5.28-8.85c1.51-3.13,2.55-6.31,3.73-9.37a46.52,46.52,0,0,1,4.12-8.68,13.43,13.43,0,0,1,6.68-5.77,11.28,11.28,0,0,1,4.43-.58c1.62.13,3.27.18,4.89.4A69,69,0,0,1,434,278l4.81,1.25a26.73,26.73,0,0,0,5,.92,13.86,13.86,0,0,0,5.09-.52,19.85,19.85,0,0,0,2.38-.86c.77-.34,1.51-.74,2.25-1.11a.2.2,0,0,0,.1-.24A.19.19,0,0,0,453.36,277.32Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.36,218.22c3.22-1.08,6.46-2.15,9.67-3.34a63.78,63.78,0,0,0,9.41-4.23,26.35,26.35,0,0,0,8-6.72,25,25,0,0,0,4.44-9.53A45.91,45.91,0,0,0,231,184c0-3.47-.26-6.86-.38-10.24a167,167,0,0,1,.23-20.27,61.11,61.11,0,0,1,4.44-19.39,34,34,0,0,1,12.36-14.86,41.19,41.19,0,0,1,8.79-4.37,85.79,85.79,0,0,1,9.61-2.68,135.7,135.7,0,0,1,20-2.52c6.76-.48,13.61-.78,20.47-1.74a88.32,88.32,0,0,0,20.16-5.2l2.42-1,1.2-.51,1.17-.59,4.65-2.37,4.44-2.71a47,47,0,0,0,4.29-2.93c1.39-1,2.83-2,4.16-3.09l4-3.28c1.35-1.06,2.58-2.26,3.86-3.42s2.55-2.31,3.72-3.58a87,87,0,0,0,12.94-16.06A58.23,58.23,0,0,0,378.08,54a29,29,0,0,0,2.11-10.08.19.19,0,0,0-.17-.19.21.21,0,0,0-.21.18v0a22,22,0,0,1-1,4.92c-.24.81-.54,1.6-.8,2.39l-1,2.34a57.77,57.77,0,0,1-5,8.74,86.1,86.1,0,0,1-13.32,15.09c-1.2,1.18-2.51,2.25-3.79,3.34s-2.53,2.22-3.89,3.22l-4,3.09c-1.33,1-2.75,1.91-4.13,2.87-2.7,2-5.67,3.54-8.53,5.24l-4.5,2.18-1.12.54-1.16.45-2.32.91A84.49,84.49,0,0,1,306,104.05c-6.62,1-13.39,1.35-20.2,1.9a138.64,138.64,0,0,0-20.45,3,85.4,85.4,0,0,0-10,3,44.35,44.35,0,0,0-9.37,4.86,36.75,36.75,0,0,0-7.79,7.2,39.11,39.11,0,0,0-5.4,9.09,63.86,63.86,0,0,0-4.37,20.3,167.87,167.87,0,0,0,.06,20.56c.16,3.41.48,6.82.51,10.15A44.42,44.42,0,0,1,228,194a23.45,23.45,0,0,1-3.95,8.92,25,25,0,0,1-7.42,6.45c-5.77,3.38-12.3,5.48-18.69,7.8-3.21,1.15-6.41,2.31-9.59,3.56-1.57.69-3.16,1.33-4.71,2.05l-2.28,1.19c-.38.2-.77.39-1.14.6l-1.09.7c-2.89,1.79-5.75,4-7.41,7.08l-.58,1.18c-.16.41-.25.84-.37,1.26a5.19,5.19,0,0,0-.21,1.29l-.06.66.05.65a8.67,8.67,0,0,0,1.89,4.81.19.19,0,0,0,.27,0,.19.19,0,0,0,0-.26v0a8.28,8.28,0,0,1-1.71-4.58l0-.61.07-.62a5,5,0,0,1,.22-1.21,11.55,11.55,0,0,1,.37-1.18l.57-1.11c1.62-2.93,4.44-5,7.31-6.71l1.08-.67c.37-.2.75-.37,1.13-.57l2.26-1.12c1.55-.69,3.13-1.29,4.69-1.94C191.91,220.4,195.13,219.31,198.36,218.22Z",
    style: {
      fill: "#31859B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rainbow--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.82,256a13.87,13.87,0,0,1,13.85,13.34h13.78a27.59,27.59,0,0,0-55.16,0H204A13.87,13.87,0,0,1,217.82,256Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,269.82H231.19l0-.48a13.36,13.36,0,0,0-26.7,0l0,.48H189.78v-.51a28.09,28.09,0,0,1,56.16,0Zm-13.82-1h12.79a27.08,27.08,0,0,0-54.12,0H203.5a14.36,14.36,0,0,1,28.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,256a13.87,13.87,0,0,1,13.85,13.34h10.2a24,24,0,0,0-48,0H204A13.87,13.87,0,0,1,217.82,256Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.38,269.82H231.19l0-.48a13.36,13.36,0,0,0-26.7,0l0,.48H193.36l0-.51a24.5,24.5,0,0,1,49,0Zm-10.24-1h9.21a23.5,23.5,0,0,0-46.95,0h9.1a14.36,14.36,0,0,1,28.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,256a13.87,13.87,0,0,1,13.85,13.34h6.81a20.62,20.62,0,0,0-41.22,0H204A13.87,13.87,0,0,1,217.82,256Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,269.82h-7.81l0-.48a13.36,13.36,0,0,0-26.7,0l0,.48h-7.7v-.52a21.12,21.12,0,0,1,42.22,0Zm-6.86-1H238a20.12,20.12,0,0,0-40.18,0h5.72a14.36,14.36,0,0,1,28.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82,256a13.87,13.87,0,0,1,13.85,13.34h3.48a17.29,17.29,0,0,0-34.56,0H204A13.87,13.87,0,0,1,217.82,256Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.67,269.82h-4.48l0-.48a13.36,13.36,0,0,0-26.7,0l0,.48h-4.37v-.52a17.79,17.79,0,0,1,35.56,0Zm-3.53-1h2.48a16.79,16.79,0,0,0-33.5,0h2.38a14.36,14.36,0,0,1,28.64,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.41,
    cy: 274.62,
    r: 7.94,
    transform: "translate(-135.81 196.72) rotate(-42.14)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.41,283.05a8.44,8.44,0,1,1,8.44-8.43A8.44,8.44,0,0,1,187.41,283.05Zm0-15.87a7.44,7.44,0,1,0,7.44,7.44A7.44,7.44,0,0,0,187.41,267.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.37,
    cy: 276.33,
    r: 7.94,
    transform: "translate(-111.63 411.49) rotate(-76.67)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,284.77a8.44,8.44,0,1,1,8.44-8.44A8.45,8.45,0,0,1,204.37,284.77Zm0-15.88a7.44,7.44,0,1,0,7.44,7.44A7.44,7.44,0,0,0,204.37,268.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,271.57a5.69,5.69,0,1,1-5.69-5.69A5.68,5.68,0,0,1,204,271.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.34,277.75a6.19,6.19,0,1,1,6.19-6.18A6.18,6.18,0,0,1,198.34,277.75Zm0-11.37a5.19,5.19,0,1,0,5.19,5.19A5.19,5.19,0,0,0,198.34,266.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.17,
    cy: 279.86,
    r: 8.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.17,288.74a8.88,8.88,0,1,1,8.88-8.88A8.89,8.89,0,0,1,199.17,288.74Zm0-16.75a7.88,7.88,0,1,0,7.88,7.87A7.89,7.89,0,0,0,199.17,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,283.49a5.69,5.69,0,1,1-5.69-5.69A5.68,5.68,0,0,1,197.3,283.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.61,289.67a6.19,6.19,0,1,1,6.19-6.18A6.18,6.18,0,0,1,191.61,289.67Zm0-11.37a5.19,5.19,0,1,0,5.19,5.19A5.19,5.19,0,0,0,191.61,278.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.58,
    cy: 274.62,
    r: 7.94,
    transform: "translate(-90.57 434.7) rotate(-76.67)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.58,283.05a8.44,8.44,0,1,1,8.43-8.43A8.45,8.45,0,0,1,229.58,283.05Zm0-15.87a7.44,7.44,0,1,0,7.43,7.44A7.45,7.45,0,0,0,229.58,267.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.54,
    cy: 276.33,
    r: 7.94,
    transform: "translate(-123.19 255.26) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.54,284.77a8.44,8.44,0,1,1,8.43-8.44A8.45,8.45,0,0,1,246.54,284.77Zm0-15.88a7.44,7.44,0,1,0,7.43,7.44A7.45,7.45,0,0,0,246.54,268.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,271.57a5.69,5.69,0,1,1-5.69-5.69A5.68,5.68,0,0,1,246.2,271.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.51,277.75a6.19,6.19,0,1,1,6.19-6.18A6.18,6.18,0,0,1,240.51,277.75Zm0-11.37a5.19,5.19,0,1,0,5.19,5.19A5.19,5.19,0,0,0,240.51,266.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.34,
    cy: 279.86,
    r: 8.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.34,288.74a8.88,8.88,0,1,1,8.87-8.88A8.89,8.89,0,0,1,241.34,288.74Zm0-16.75a7.88,7.88,0,1,0,7.87,7.87A7.88,7.88,0,0,0,241.34,272Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.46,283.49a5.69,5.69,0,1,1-5.68-5.69A5.68,5.68,0,0,1,239.46,283.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.78,289.67a6.19,6.19,0,1,1,6.18-6.18A6.19,6.19,0,0,1,233.78,289.67Zm0-11.37a5.19,5.19,0,1,0,5.18,5.19A5.2,5.2,0,0,0,233.78,278.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ballons--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.14,113.83c-5.14,14.46-22.23,31.09-34.47,26.74s-15-28-9.86-42.49S167,75.43,179.28,79.78,197.27,99.38,192.14,113.83Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.88,141.78a13.08,13.08,0,0,1-4.38-.74c-12.91-4.59-15.06-29.33-10.16-43.13a30.84,30.84,0,0,1,13.29-16.46,21.56,21.56,0,0,1,32.06,11.39,30.85,30.85,0,0,1-.08,21.16C188.24,126.29,174.05,141.78,161.88,141.78Zm10.59-62.67a22.58,22.58,0,0,0-11.34,3.2,29.86,29.86,0,0,0-12.85,15.94c-5.35,15-1.92,37.77,9.56,41.85s28.48-11.39,33.82-26.43a29.83,29.83,0,0,0,.1-20.47,21.25,21.25,0,0,0-12.65-13A19.9,19.9,0,0,0,172.47,79.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.7,202.09a4.72,4.72,0,0,1-3.64-1.41c-3-3.22-.83-10.76.72-15,.81-2.21.46-3.91-1-5.07-3.22-2.48-11.56-1.93-17.92,2.51-5.19,3.64-10.7,4.81-15.11,3.22-3.53-1.28-6-4.19-7.16-8.42-2.58-9.46,9.23-16.75,19.64-23.18l2.53-1.57c10.24-6.4,8.49-12.43,8.47-12.49a.51.51,0,0,1,.33-.63.51.51,0,0,1,.63.33c.09.27,2.06,6.79-8.9,13.64l-2.53,1.57c-10.12,6.25-21.59,13.33-19.2,22.06,1.06,3.91,3.32,6.58,6.53,7.75,4.1,1.48,9.28.35,14.2-3.1,6.23-4.36,15.16-5.52,19.1-2.48,1.84,1.41,2.32,3.62,1.37,6.2-2.47,6.7-2.81,11.91-.92,13.94,1.1,1.19,3,1.4,5.69.64a.51.51,0,0,1,.62.34.5.5,0,0,1-.35.62A11,11,0,0,1,170.7,202.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.9,92.57c0,3.92-2.83,7.1-6.32,7.1s-6.32-3.18-6.32-7.1,2.83-7.11,6.32-7.11S184.9,88.64,184.9,92.57Z",
    style: {
      fill: "#fff",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.56,207.48c4.22,9.6,3.53,25.88-4.6,29.46s-20.6-6.9-24.83-16.5-1.06-20.27,7.06-23.85S279.33,197.89,283.56,207.48Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.38,238.16c-3.18,0-6.82-1.4-10.59-4.12a35.27,35.27,0,0,1-11.11-13.4c-4.34-9.83-1.05-20.82,7.31-24.51s18.69,1.32,23,11.15c4.06,9.22,3.81,26.31-4.84,30.12A9.4,9.4,0,0,1,275.38,238.16Zm-8.58-42.24a13.3,13.3,0,0,0-5.41,1.13c-7.86,3.46-10.91,13.86-6.8,23.19a34.29,34.29,0,0,0,10.79,13c5.07,3.66,9.82,4.82,13.38,3.25,7.55-3.32,8.71-18.87,4.34-28.79C279.9,200.42,273.28,195.92,266.8,195.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,200.31a4.35,4.35,0,1,1-6.47-.57A4.61,4.61,0,0,1,270,200.31Z",
    style: {
      fill: "#fff",
      opacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.31,277.44a9.18,9.18,0,0,1-2.36-.32,8.78,8.78,0,0,1-6.53-7.63c-.38-5.61,3.7-8.34,7.63-11l1.67-1.13c4.35-3,6.62-5.86,6.4-7.91-.13-1.24-1.21-2.29-3.2-3.12a16.4,16.4,0,0,0-4.86-1,28.21,28.21,0,0,1-3-.4c-3.64-.72-6-3.23-7.56-7.88a.5.5,0,0,1,.95-.31c1.4,4.27,3.56,6.56,6.8,7.21.95.19,1.95.29,2.92.39a17.53,17.53,0,0,1,5.14,1c2.36,1,3.64,2.31,3.82,3.94.33,3.11-3.53,6.53-6.83,8.84-.55.39-1.11.76-1.68,1.14-3.87,2.6-7.53,5.05-7.19,10.09a7.75,7.75,0,0,0,5.8,6.72c3.57,1,7.19-.6,9.67-4.24a75.07,75.07,0,0,0,4.17-7.1c3.49-6.45,6.49-12,13.15-11.33,4.32.46,6.51,2.82,8.12,4.54,1.79,1.92,2.69,2.89,5.18,1a.51.51,0,0,1,.7.1.5.5,0,0,1-.1.7c-3.21,2.41-4.74.77-6.51-1.14-1.58-1.7-3.55-3.81-7.5-4.22-6-.62-8.71,4.42-12.16,10.81a78.51,78.51,0,0,1-4.22,7.18C296.52,275.69,293.49,277.44,290.31,277.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bird--inject-12"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200.54,
    cy: 163.69,
    r: 13.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.54,177.51a13.82,13.82,0,1,1,13.83-13.82A13.84,13.84,0,0,1,200.54,177.51Zm0-26.64a12.82,12.82,0,1,0,12.83,12.82A12.83,12.83,0,0,0,200.54,150.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.07,
    cy: 156.93,
    r: 2.1,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.85 157.23 213.94 155.88 216.23 162.54 220.85 157.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,163.52l-2.85-8.29,8.61,1.68Zm-1.34-7,1.73,5,3.48-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.81,193.13H200V177a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v15.12h4.77a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.78,193.13h-6.66a.5.5,0,0,1,0-1h5.66V176.39a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,160.15s-3.64-5.61-8.12-5.89-12.88,1.13-11.2,2.81,5.32,1.4,5.32,1.4-3.64,3.36-.56,4.2a7.76,7.76,0,0,0,5.88-1.12s-.84,2.8,1.4,3.36,4.2-3.36,4.2-3.36-.28,3.64.84,3.64,3.08-1.68,3.08-1.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.16,165.69a1,1,0,0,1-.74-.34,3.67,3.67,0,0,1-.61-2.06c-.86,1.16-2.24,2.5-3.81,2.1a2.38,2.38,0,0,1-1.56-1.14,3.25,3.25,0,0,1-.37-1.76,7.76,7.76,0,0,1-5.36.66,1.94,1.94,0,0,1-1.56-1.34,3.7,3.7,0,0,1,1.1-2.84,7.07,7.07,0,0,1-4.52-1.55,1,1,0,0,1-.28-1.2c.81-1.8,8.28-2.68,11.86-2.45,4.68.29,8.36,5.87,8.51,6.1a.5.5,0,0,1-.14.69.51.51,0,0,1-.7-.14c0-.06-3.55-5.4-7.73-5.66-4.57-.28-10.63,1-10.89,1.87,0,0,0,0,.08.08,1.5,1.5,4.89,1.26,4.92,1.26l1.44-.11-1.06,1c-.61.57-1.8,2-1.62,2.74.07.27.36.48.85.61a7.37,7.37,0,0,0,5.47-1l1.16-.82-.4,1.37a3.15,3.15,0,0,0,.11,2.07,1.39,1.39,0,0,0,.93.66c1.52.38,3.14-2.11,3.64-3.1L195,159l-.2,2.54c-.12,1.57.09,3,.36,3.11a6.72,6.72,0,0,0,2.74-1.56.49.49,0,0,1,.7.05.51.51,0,0,1-.05.71C198.35,164.07,196.43,165.69,195.16,165.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267,171.79c.77-1,1.2-3.16.23-3.93s-3,.16-3.77,1.14a6.82,6.82,0,0,0-.53,4.32C263.11,173.48,266.21,172.76,267,171.79Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.55,186.4c1.72-2.19,2.67-7.05.49-8.77s-6.69.35-8.4,2.54-1.8,9.19-1.2,9.66S287.83,188.58,289.55,186.4Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.74,200.73c.77-1,1.2-3.15.22-3.92s-3,.15-3.76,1.13a6.85,6.85,0,0,0-.54,4.32C299.87,202.43,303,201.71,303.74,200.73Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.58,158.9l21.14-1.16-7.34,9.33-16-3.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.57,167.62l-16.9-3.89,2.59-5.31,22.53-1.24ZM273.12,163l15.06,3.47,6.46-8.21-19.74,1.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,169.92l-5.42-4.26,15.6-22.18a2.76,2.76,0,0,1,.37-.46c1.57-1.61,7.76-6.07,9.77-4.49h0c2,1.59-.87,8.65-2.06,10.56a3.24,3.24,0,0,1-.37.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,170.61l-6.17-4.85,15.88-22.57a4.15,4.15,0,0,1,.42-.52c1.24-1.27,7.94-6.5,10.44-4.53s-1,9.71-1.95,11.21a4.22,4.22,0,0,1-.42.55Zm-4.8-5.05,4.67,3.68,17.59-20a2.87,2.87,0,0,0,.31-.4c1.41-2.25,3.7-8.69,2.18-9.89s-7.24,2.54-9.11,4.44a2.79,2.79,0,0,0-.3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,140.53l6.21,4.89c1-2.7,1.66-5.88.39-6.89S286.09,139,283.7,140.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,146.24l-7.29-5.75.58-.38c2.4-1.59,5.59-3.22,7.18-2s.75,4.74-.23,7.45Zm-5.58-5.67,5.11,4c1-2.91,1.1-5.05.32-5.66S287.16,138.94,284.56,140.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.85 160.98 264.56 165.66 269.98 169.93 273.75 165.63 267.85 160.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,170.61l-6.17-4.85,3.87-5.5,6.74,5.3Zm-4.8-5.05,4.67,3.68,3.12-3.55-5.08-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.17,187.71l-3.84-20.82L300,176.21l7.33,14.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.15,191.67l-7.75-15.52,8.22-10.44,4.09,22.19Zm-6.57-15.4,6.91,13.82,3.13-2.58L307,168.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.53,194.77,307,199l17.9-20.38a2.71,2.71,0,0,0,.36-.46c1.19-1.91,4.08-9,2.07-10.55h0c-2-1.59-8.2,2.87-9.78,4.48a2.6,2.6,0,0,0-.36.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,199.72l-6.17-4.85,15.88-22.57a3,3,0,0,1,.42-.52c1.24-1.27,7.92-6.5,10.44-4.53s-1,9.71-2,11.21a3.09,3.09,0,0,1-.42.55Zm-4.81-5.05,4.68,3.68,17.58-20a2.34,2.34,0,0,0,.32-.4c1.41-2.25,3.7-8.69,2.18-9.89s-7.25,2.54-9.11,4.44a2.72,2.72,0,0,0-.31.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.73 194.74 306.95 199.04 301.53 194.77 304.82 190.09 310.73 194.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,199.72l-6.17-4.85,3.87-5.5,6.73,5.3Zm-4.81-5.05,4.68,3.68,3.11-3.54-5.07-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,169.64l6.21,4.89c1-2.7,1.66-5.88.39-6.88S323.07,168.06,320.68,169.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.12,175.35l-7.29-5.75.57-.38c2.4-1.59,5.6-3.22,7.19-2s.75,4.74-.23,7.45Zm-5.58-5.67,5.1,4c1-2.91,1.1-5,.33-5.66S324.14,168.05,321.54,169.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,180.51l-14.2-11.18,33.26-48.42a7.89,7.89,0,0,1,1-1.2c4.13-4.21,20.33-15.89,25.6-11.75h0c5.26,4.15-2.28,22.64-5.41,27.64a7.41,7.41,0,0,1-1,1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.89,181.19,284,169.43l33.52-48.8a7.57,7.57,0,0,1,1-1.27c3.68-3.76,20.53-16.3,26.26-11.79s-2.51,23.84-5.3,28.3a8.59,8.59,0,0,1-1,1.29Zm-13.58-12,13.46,10.6,39-43.35a7.75,7.75,0,0,0,.9-1.14c3.16-5.06,10.34-23.19,5.52-27s-20.75,7.43-24.93,11.7a8,8,0,0,0-.9,1.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.39,152.53h0c-3.43-2.69-4.65-6.86-2.73-9.29l14.48-18.4c1.92-2.44,6.26-2.23,9.68.47h0c3.43,2.7,4.65,6.86,2.73,9.3L319.07,153C317.15,155.44,312.82,155.23,309.39,152.53Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.15,155.2h-.38a10.77,10.77,0,0,1-9.23-7.26,5.42,5.42,0,0,1,.73-5l14.48-18.4c2.09-2.65,6.74-2.47,10.38.39s4.9,7.35,2.81,10l-14.48,18.39A5.28,5.28,0,0,1,315.15,155.2Zm9.92-31.56a4.35,4.35,0,0,0-3.53,1.51l-14.49,18.39a4.48,4.48,0,0,0-.55,4.11,9.2,9.2,0,0,0,3.2,4.49h0a9.12,9.12,0,0,0,5.12,2.05,4.42,4.42,0,0,0,3.86-1.5l14.48-18.39c1.74-2.22.56-6.07-2.65-8.59A9,9,0,0,0,325.07,123.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.51 185.45 281.53 177.59 284.87 169.03 299.07 180.21 291.51 185.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,186.07l-10.56-8.31,3.72-9.54,15.26,12Zm-9.36-8.64,9.4,7.4,6.7-4.64-13.14-10.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.52,135.84a5.51,5.51,0,1,1-.92-7.75A5.52,5.52,0,0,1,329.52,135.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.11,136.36a5.51,5.51,0,1,1-.92-7.75A5.52,5.52,0,0,1,329.11,136.36Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77,139a6,6,0,1,1,4.74-2.29h0A6,6,0,0,1,324.77,139Zm0-11a4,4,0,0,0-.6,0,5,5,0,0,0-3.35,1.87,5,5,0,1,0,7.88,6.21h0a5,5,0,0,0-.84-7A4.93,4.93,0,0,0,324.79,127.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.73,129.2a5.18,5.18,0,0,1,1,7.11,2,2,0,0,0,.14-.16,5.18,5.18,0,0,0-8.14-6.41l-.12.17A5.19,5.19,0,0,1,327.73,129.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,135.49a4.12,4.12,0,1,1-.68-5.78A4.11,4.11,0,0,1,328,135.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77,137.56a4.62,4.62,0,0,1-.54-9.2,4.62,4.62,0,0,1,4.18,7.44h0a4.58,4.58,0,0,1-3.08,1.73A5.25,5.25,0,0,1,324.77,137.56Zm0-8.23-.44,0a3.61,3.61,0,0,0-2.41,1.36,3.55,3.55,0,0,0-.75,2.66,3.61,3.61,0,0,0,6.43,1.81h0a3.54,3.54,0,0,0,.75-2.66A3.58,3.58,0,0,0,327,130.1,3.65,3.65,0,0,0,324.79,129.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,135.88a4.12,4.12,0,0,0,5.66-.54l-.12.15a4.12,4.12,0,1,1-6.47-5.09l.13-.15A4.12,4.12,0,0,0,322.47,135.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,146.54a5.52,5.52,0,1,1-.93-7.74A5.52,5.52,0,0,1,321.1,146.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,147.06a5.51,5.51,0,1,1-.92-7.74A5.51,5.51,0,0,1,320.68,147.06Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.34,149.66a6,6,0,1,1,3.73-10.73,6,6,0,0,1,1,8.44h0A6,6,0,0,1,316.34,149.66Zm0-11a5,5,0,1,0,3.09,1.07A5,5,0,0,0,316.36,138.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.3,139.91a5.16,5.16,0,0,1,1,7.1l.14-.15a5.18,5.18,0,1,0-8.14-6.41l-.12.17A5.17,5.17,0,0,1,319.3,139.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.59,146.2a4.12,4.12,0,1,1-.69-5.78A4.13,4.13,0,0,1,319.59,146.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.34,148.27a4.57,4.57,0,1,1,.56,0A5.25,5.25,0,0,1,316.34,148.27Zm0-8.24a3.25,3.25,0,0,0-.44,0,3.61,3.61,0,0,0-3.16,4,3.62,3.62,0,0,0,6.43,1.81h0a3.61,3.61,0,0,0-.6-5.08A3.56,3.56,0,0,0,316.36,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,146.58a4.11,4.11,0,0,0,5.66-.54l-.11.16a4.12,4.12,0,1,1-6.47-5.1l.12-.14A4.11,4.11,0,0,0,314,146.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.18,111.31l14.36,11.31c2-6.25,3-12.73.14-15h0C341.86,105.44,335.79,107.92,330.18,111.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.8,123.46l-15.5-12.2.62-.37c5.07-3.07,11.8-6.19,15.07-3.62s1.82,9.85,0,15.51Zm-13.74-12.09,13.22,10.41c2.19-7.18,2.23-12,.09-13.72S337.53,107.56,331.06,111.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.17,
    y1: 152.29,
    x2: 293.97,
    y2: 152.58,
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.12,
    y1: 152.36,
    x2: 293.97,
    y2: 152.58,
    style: {
      fill: "#9ba7ac"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.03,
    y1: 152.49,
    x2: 293.97,
    y2: 152.58,
    style: {
      fill: "#697b82"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "408.01 91.38 413.66 84.51 405.05 82.27 405.58 73.39 397.3 76.63 392.5 69.14 387.71 76.63 379.42 73.39 379.95 82.27 371.34 84.51 377 91.38 371.34 98.26 379.95 100.5 379.42 109.38 387.71 106.14 392.5 113.63 397.3 106.14 405.58 109.38 405.05 100.5 413.66 98.26 408.01 91.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,114.56l-5-7.81-8.63,3.38.55-9.25-9-2.33,5.89-7.17-5.89-7.16,9-2.33-.55-9.25L387.51,76l5-7.8,5,7.8,8.63-3.37-.56,9.25,9,2.33-5.89,7.16,5.89,7.16-9,2.34.56,9.25-8.63-3.38Zm-4.59-9,4.59,7.18,4.6-7.18,7.93,3.11-.5-8.51L412.78,98l-5.42-6.59,5.42-6.59-8.25-2.14.5-8.51-7.93,3.1-4.6-7.17-4.59,7.17L380,74.14l.51,8.51-8.26,2.14,5.42,6.59L372.22,98l8.26,2.15-.51,8.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.5,
    cy: 91.38,
    r: 12.41,
    transform: "translate(-10.5 92.12) rotate(-13.21)",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.5,104.29a12.91,12.91,0,1,1,12.91-12.91A12.92,12.92,0,0,1,392.5,104.29Zm0-24.81a11.91,11.91,0,1,0,11.91,11.9A11.92,11.92,0,0,0,392.5,79.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spaceship--inject-12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.61,
    cy: 55.87,
    rx: 11.17,
    ry: 9.31,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.61,65.68c-6.43,0-11.67-4.4-11.67-9.81s5.24-9.81,11.67-9.81,11.67,4.4,11.67,9.81S340,65.68,333.61,65.68Zm0-18.62c-5.88,0-10.67,3.95-10.67,8.81s4.79,8.81,10.67,8.81,10.67-4,10.67-8.81S339.49,47.06,333.61,47.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.61,
    cy: 54.86,
    rx: 23.93,
    ry: 8.24,
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.61,63.6c-13.7,0-24.43-3.84-24.43-8.74s10.73-8.75,24.43-8.75S358,50,358,54.86,347.31,63.6,333.61,63.6Zm0-16.49c-12.7,0-23.43,3.55-23.43,7.75s10.73,7.74,23.43,7.74S357,59.06,357,54.86,346.31,47.11,333.61,47.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.78,49c0,5.14-5,5.85-11.17,5.85s-11.17-.71-11.17-5.85,5-9.31,11.17-9.31S344.78,43.87,344.78,49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.61,55.36c-5.65,0-11.67-.49-11.67-6.35,0-5.41,5.24-9.81,11.67-9.81s11.67,4.4,11.67,9.81C345.28,54.87,339.26,55.36,333.61,55.36Zm0-15.16c-5.88,0-10.67,3.95-10.67,8.81,0,4.45,4.08,5.35,10.67,5.35s10.67-.9,10.67-5.35C344.28,44.15,339.49,40.2,333.61,40.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.44,56.51c0,.85-1.14,1.53-2.54,1.53s-2.55-.68-2.55-1.53S316.49,55,317.9,55,320.44,55.67,320.44,56.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,58.54c-1.71,0-3-.89-3-2s1.34-2,3-2,3.05.89,3.05,2S319.61,58.54,317.9,58.54Zm0-3.06c-1.18,0-2,.55-2,1s.87,1,2,1,2.05-.54,2.05-1S319.07,55.48,317.9,55.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.06,59.16c0,.85-1.27,1.53-2.85,1.53s-2.85-.68-2.85-1.53,1.27-1.53,2.85-1.53S332.06,58.32,332.06,59.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.21,61.19c-1.91,0-3.35-.87-3.35-2s1.44-2,3.35-2,3.35.87,3.35,2S331.12,61.19,329.21,61.19Zm0-3.06c-1.44,0-2.35.61-2.35,1s.91,1,2.35,1,2.35-.61,2.35-1S330.65,58.13,329.21,58.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.74,57.43c0,.79-1.23,1.43-2.75,1.43s-2.75-.64-2.75-1.43S342.47,56,344,56,346.74,56.64,346.74,57.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,59.36c-1.86,0-3.25-.83-3.25-1.93s1.39-1.93,3.25-1.93,3.25.83,3.25,1.93S345.84,59.36,344,59.36Zm0-2.86c-1.38,0-2.25.55-2.25.93s.87.93,2.25.93,2.25-.55,2.25-.93S345.36,56.5,344,56.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.06,52.44c0,.5-.78.91-1.73.91s-1.74-.41-1.74-.91.78-.92,1.74-.92S353.06,51.93,353.06,52.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.33,53.85c-1.28,0-2.24-.61-2.24-1.41s1-1.42,2.24-1.42,2.23.61,2.23,1.42S352.6,53.85,351.33,53.85Zm0-1.83c-.81,0-1.22.32-1.24.42s.43.41,1.24.41,1.21-.32,1.23-.41S352.13,52,351.33,52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.83,51.31c0,.51-.77.92-1.73.92s-1.73-.41-1.73-.92.77-.91,1.73-.91S319.83,50.81,319.83,51.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.1,52.73c-1.27,0-2.23-.61-2.23-1.42s1-1.41,2.23-1.41,2.23.61,2.23,1.41S319.37,52.73,318.1,52.73Zm0-1.83c-.81,0-1.22.32-1.23.41s.42.42,1.23.42,1.22-.32,1.23-.42S318.91,50.9,318.1,50.9Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Planets--inject-12"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250.06,
    cy: 79.04,
    r: 18.73,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.06,98.27A19.23,19.23,0,1,1,269.29,79,19.25,19.25,0,0,1,250.06,98.27Zm0-37.45A18.23,18.23,0,1,0,268.29,79,18.24,18.24,0,0,0,250.06,60.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6,75.4a1.94,1.94,0,1,1-1.94-1.93A1.94,1.94,0,0,1,241.6,75.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.66,77.84a2.44,2.44,0,1,1,2.44-2.44A2.43,2.43,0,0,1,239.66,77.84Zm0-3.87a1.44,1.44,0,1,0,1.44,1.43A1.43,1.43,0,0,0,239.66,74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.06,70a3.49,3.49,0,1,1-3.49-3.49A3.49,3.49,0,0,1,256.06,70Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.57,74a4,4,0,1,1,4-4A4,4,0,0,1,252.57,74Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,252.57,67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.57,86.51a1.94,1.94,0,1,1-1.93-1.94A1.92,1.92,0,0,1,248.57,86.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,88.94a2.44,2.44,0,1,1,2.43-2.43A2.43,2.43,0,0,1,246.64,88.94Zm0-3.87a1.44,1.44,0,1,0,1.43,1.44A1.44,1.44,0,0,0,246.64,85.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.58,
    cy: 77.34,
    r: 2.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.58,79.91a2.57,2.57,0,1,1,2.57-2.57A2.57,2.57,0,0,1,264.58,79.91Zm0-4.14a1.57,1.57,0,1,0,1.57,1.57A1.57,1.57,0,0,0,264.58,75.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.42,91a1.29,1.29,0,1,1-1.29-1.29A1.29,1.29,0,0,1,259.42,91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.13,92.82A1.79,1.79,0,1,1,259.92,91,1.79,1.79,0,0,1,258.13,92.82Zm0-2.58a.79.79,0,1,0,0,1.58.79.79,0,1,0,0-1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.84,
    cy: 160.44,
    r: 23.38,
    transform: "translate(-7.29 18.9) rotate(-2.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.81,184.33a23.89,23.89,0,1,1,22.95-30.58h0a23.91,23.91,0,0,1-22.95,30.58Zm.07-46.78a22.89,22.89,0,0,0-11,43,22.88,22.88,0,1,0,11-43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.43,183.78l24.76-22.07a23.14,23.14,0,0,0-.91-7.82c-.1-.37-.22-.74-.34-1.09l-25.86,30.72A23.13,23.13,0,0,0,386.43,183.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.61,184.29h-.21c-.81-.05-1.62-.14-2.4-.26l-.87-.15,27-32.07.29.83c.13.37.24.74.35,1.12a23.67,23.67,0,0,1,.93,8v.21Zm-1.56-1.14c.39,0,.8.09,1.21.12l24.44-21.8a22.85,22.85,0,0,0-.9-7.44l-.06-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,161.07c2.9-5.29,8.25-14.87,11.57-20.81A23.44,23.44,0,0,0,364.47,161.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,162.93l0-1.84a23.86,23.86,0,0,1,11.81-21.26l1.59-.92-.9,1.6c-3.73,6.68-8.77,15.72-11.56,20.8Zm10.6-21.16a22.85,22.85,0,0,0-9.62,17.3C367.61,154.33,371.45,147.46,374.62,141.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47,167.46l-8.38,9.29a24,24,0,0,0,3,2.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.3,180.11l-.5-.36a23.62,23.62,0,0,1-3.07-2.66l-.33-.33,10.84-12Zm-2.52-3.38a22,22,0,0,0,2.12,1.84l3.79-8.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,149.88a23.82,23.82,0,0,0-2.49-3.91l-12.84,12.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,160.91l15.95-15.68.35.43a24.07,24.07,0,0,1,2.54,4l.22.43Zm15.85-14.18-9.7,9.53L408,149.68A22.66,22.66,0,0,0,406.15,146.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.25,138a23.7,23.7,0,0,0-5-.86l-21.46,35.4c.16.27.33.54.51.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.29,174.18l-.39-.6c-.18-.27-.35-.55-.52-.82l-.15-.26L389,136.59l.3,0a23.19,23.19,0,0,1,5.08.87l.7.2Zm21.25-36.56-20.63,34,24.5-33.4A23.3,23.3,0,0,0,389.54,137.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.66,146.58a24.77,24.77,0,0,1,1.39,2.11c3.08.15,5.05.82,5.42,2.07,1,3.35-10.09,9.54-24.72,13.81s-27.28,5-28.26,1.67c-.39-1.33,1.12-3.11,4-5a22.22,22.22,0,0,1,0-2.45c-6.93,3.74-11,7.53-10.17,10.22,1.39,4.76,17.23,4.32,35.39-1s31.74-13.47,30.35-18.23C419.33,147.14,414.17,146.1,406.66,146.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,172.77c-4.6,0-9.68-.7-10.54-3.66-1.14-3.89,6-8.44,10.42-10.8l.8-.43-.07.91a21.24,21.24,0,0,0,0,2.4v.27l-.24.16c-2.71,1.82-4.1,3.45-3.8,4.48.78,2.65,12.32,2.47,27.65-2S413.76,153.55,413,150.9c-.28-1-2.09-1.57-5-1.71h-.27l-.14-.24a21.46,21.46,0,0,0-1.35-2.06l-.54-.74.91-.06c8.18-.52,13.13.74,13.95,3.54.95,3.26-3.86,6.95-8.07,9.48a100.7,100.7,0,0,1-22.62,9.37,100.34,100.34,0,0,1-24.11,4.28C365.33,172.77,364.88,172.77,364.42,172.77ZM364,159.62c-6.4,3.57-9.8,7-9.15,9.21.59,2,4.58,3.1,10.91,2.92a99.27,99.27,0,0,0,23.86-4.24A99.78,99.78,0,0,0,412,158.24c5.44-3.26,8.21-6.3,7.62-8.34s-5.09-3.21-12-2.87c.26.39.51.78.75,1.18,3.31.19,5.19,1,5.61,2.41,1.24,4.26-12,10.61-25.06,14.43s-27.64,5.59-28.88,1.33c-.44-1.5.89-3.33,4-5.44C364,160.5,364,160.06,364,159.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ship--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.82,250.74S377.4,233.59,385,231.08s17.54,3.76,26.49,9.34,15.8,6.47,9.4,9.54-15.73-1.68-15.73-1.68,4.66,5.13,1.42,5.65-10.68-5.62-10.68-5.62,5.15,4.6-.24,4.89-11.25-4.39-11.25-4.39,1.16,4-.87,4.11-8.8-4.27-8.8-4.27,1.42,2.9-2.31,3.95S361.82,250.74,361.82,250.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.21,254.46c-2.16,0-5.39-2-7.74-3.6a2.06,2.06,0,0,1,.09,1.44c-.29.84-1.25,1.31-2.83,1.4-4.19.24-8.56-2.37-10.53-3.72a4.08,4.08,0,0,1-.36,2.8,1.55,1.55,0,0,1-1.24.64h-.06c-1.74,0-6-2.47-8-3.7a3,3,0,0,1-.24,1.37,3.84,3.84,0,0,1-2.69,2c-3.86,1.08-10.69-1.76-11-1.88l-.65-.28.47-.52c.64-.7,15.76-17.27,23.44-19.79s17.76,3.68,26.57,9.18l.34.21c2.58,1.61,5,2.84,7,3.82,3.24,1.64,5.19,2.63,5.18,4,0,.89-.85,1.67-2.79,2.6-4.85,2.33-11.17.4-14.28-.84.84,1.18,1.67,2.73,1.3,3.79a1.67,1.67,0,0,1-1.47,1.06A2.63,2.63,0,0,1,406.21,254.46Zm-10-6.54c2,1.67,7.84,5.91,10.29,5.52.57-.1.66-.33.69-.41.3-.88-1.22-3.11-2.4-4.41l-1.84-2,2.43,1.24c.09,0,9.19,4.6,15.29,1.67,1.93-.92,2.23-1.47,2.23-1.71,0-.74-2.14-1.82-4.64-3.08-2-1-4.41-2.24-7-3.87l-.34-.21c-8.62-5.38-18.4-11.49-25.73-9.08-6.68,2.19-19.81,16.07-22.51,19,1.79.68,6.79,2.38,9.65,1.58a2.94,2.94,0,0,0,2-1.43,2.44,2.44,0,0,0-.05-1.82l-.79-1.61,1.51,1c2.64,1.69,7.05,4.19,8.47,4.19h0a.56.56,0,0,0,.47-.23c.46-.62.21-2.32-.06-3.24l-.43-1.5,1.22,1c.06.05,5.82,4.55,10.91,4.28,1.11-.06,1.8-.32,1.95-.73.27-.78-1-2.39-2-3.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,238.29s-.38,3.58-3.39,4.7c-2.56,1-8-3.89-8-3.89s2.18,4-.27,3.88a54.71,54.71,0,0,1-6.54-1,1.85,1.85,0,0,1-.2,3.16c-2.18,1.51-7.49,1.08-7.49,1.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,246.79c-.95,0-1.63,0-1.71-.06a.5.5,0,0,1-.46-.54.48.48,0,0,1,.54-.45c.05,0,5.16.39,7.17-1a1.57,1.57,0,0,0,.81-1.11,1.87,1.87,0,0,0-.66-1.26L377,241.09l1.94.41a52.75,52.75,0,0,0,6.47,1c.44,0,.52-.12.55-.17.32-.51-.26-2.07-.75-3l-1.38-2.54,2.16,1.93c1.44,1.29,5.59,4.49,7.46,3.8,2.68-1,3.07-4.26,3.08-4.29a.5.5,0,1,1,1,.11c0,.15-.45,3.89-3.72,5.11-1.93.73-5-1.28-6.93-2.71a2.77,2.77,0,0,1-.06,2.09,1.53,1.53,0,0,1-1.45.64,45,45,0,0,1-5.38-.75,2.08,2.08,0,0,1,.18.94,2.48,2.48,0,0,1-1.23,1.9C377.4,246.6,374.61,246.79,372.8,246.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.78,
    y: 208.82,
    width: 10.61,
    height: 25.41,
    transform: "translate(648.53 560.63) rotate(-159.45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,235.93,365,231.86l9.27-24.73,10.88,4.07Zm-9.59-4.66,9,3.38,8.57-22.86-9-3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.2,
    y: 209.44,
    width: 10.61,
    height: 5.92,
    transform: "translate(658.36 544.16) rotate(-159.45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.73,217.68l-10.88-4.08,2.43-6.47,10.88,4.07ZM373.14,213l9,3.37,1.73-4.6-9-3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.5,249.43l2.23-5a2.58,2.58,0,0,0-1.45-3.47l-1.64-.61a2.59,2.59,0,0,1-1.51-3.33l.45-1.18a2.59,2.59,0,0,0-1.52-3.33l-17.75-6.65a2.57,2.57,0,0,0-3.32,1.51l-4.28,11.4a2.59,2.59,0,0,0,1.54,3.33l24,8.72A2.59,2.59,0,0,0,383.5,249.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.13,251.46a3.12,3.12,0,0,1-1-.18l-24-8.72a3.08,3.08,0,0,1-1.84-4l4.28-11.4a3.08,3.08,0,0,1,4-1.8L380.24,232a3.08,3.08,0,0,1,1.8,4l-.44,1.19a2,2,0,0,0,0,1.59,2.09,2.09,0,0,0,1.17,1.09l1.64.61a3.09,3.09,0,0,1,1.73,4.15l-2.23,5A3.1,3.1,0,0,1,381.13,251.46Zm-19.72-25.28a2,2,0,0,0-.87.19,2.1,2.1,0,0,0-1.09,1.16l-4.27,11.4a2.09,2.09,0,0,0,.06,1.61,2.06,2.06,0,0,0,1.18,1.08l24,8.72a2.09,2.09,0,0,0,2.61-1.11l2.24-5a2.1,2.1,0,0,0,0-1.65,2.06,2.06,0,0,0-1.2-1.15l-1.63-.61a3.09,3.09,0,0,1-1.81-4l.45-1.18a2.09,2.09,0,0,0-.06-1.59,2,2,0,0,0-1.16-1.09l-17.75-6.66A2.08,2.08,0,0,0,361.41,226.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.29,254.7l-8.37,8.92a9.86,9.86,0,0,1-10.66,2.49L345,258.51a9.86,9.86,0,0,1-6.4-9.22l0-14.15Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.73,267.24a10.26,10.26,0,0,1-3.64-.66L344.8,259a10.39,10.39,0,0,1-6.72-9.68l0-14.91,47.09,20.14L376.28,264A10.31,10.31,0,0,1,368.73,267.24ZM339.05,235.9l0,13.39a9.39,9.39,0,0,0,6.07,8.75l20.29,7.6a9.32,9.32,0,0,0,10.11-2.36l7.89-8.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.7,236.85l47.59,17.85a3.71,3.71,0,0,0,4.76-2.17h0a3.7,3.7,0,0,0-2.16-4.76L339.3,229.93a3.7,3.7,0,0,0-4.76,2.16h0A3.69,3.69,0,0,0,336.7,236.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.59,255.43a4.2,4.2,0,0,1-1.47-.27l-47.59-17.84a4.2,4.2,0,0,1,3-7.86l47.58,17.84a4.2,4.2,0,0,1-1.47,8.13Zm-48.71-19,47.59,17.84a3.2,3.2,0,1,0,2.24-6L339.13,230.4a3.2,3.2,0,0,0-2.45.08,3.16,3.16,0,0,0-1.67,1.79,3.19,3.19,0,0,0,1.87,4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,235a3.22,3.22,0,1,1,1.88,4.14A3.22,3.22,0,0,1,367.46,235Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.47,240.33a4.28,4.28,0,0,1-1.48-.26,4.23,4.23,0,0,1-2.36-2.21,4.18,4.18,0,0,1-.1-3.22h0a4.21,4.21,0,0,1,5.42-2.47,4.21,4.21,0,0,1-1.48,8.16Zm0-6.43a2.23,2.23,0,0,0-2.07,1.44h0a2.18,2.18,0,0,0,.06,1.7,2.16,2.16,0,0,0,1.24,1.15,2.22,2.22,0,1,0,1.55-4.15A2.29,2.29,0,0,0,370.47,233.9Zm-3,1.09h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12,252.91s23-2.71,30.42.41,10.76,14.34,13.85,24.43,7.68,15.25.83,13.37-10.77-11.6-10.77-11.6.15,6.93-2.63,5.2-4.37-11.26-4.37-11.26.87,6.85-3.39,3.54-5.61-10.69-5.61-10.69-1.77,3.8-3.35,2.52-3.84-9-3.84-9-.83,3.13-4.33,1.47S362.12,252.91,362.12,252.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.42,292a9.5,9.5,0,0,1-2.33-.4c-5.19-1.43-8.68-7-10.22-10-.15,1.44-.53,3.16-1.5,3.71a1.67,1.67,0,0,1-1.82-.16c-1.83-1.14-3.12-5.09-3.86-8.08a2.08,2.08,0,0,1-.88,1.14c-.77.44-1.8.17-3.05-.8-3.31-2.58-4.91-7.41-5.51-9.72a4,4,0,0,1-2.1,1.87,1.52,1.52,0,0,1-1.36-.33c-1.32-1.07-2.93-5.8-3.65-8.08a3,3,0,0,1-1.09.88,3.88,3.88,0,0,1-3.33-.26c-3.62-1.72-6.91-8.35-7.05-8.63l-.31-.63.7-.09c.94-.11,23.22-2.69,30.67.45s11,14.44,14,24.37l.11.38c.89,2.91,1.92,5.42,2.74,7.45,1.37,3.36,2.2,5.39,1.3,6.4A1.86,1.86,0,0,1,409.42,292Zm-13.53-15.2,1,2.53c0,.1,3.9,9.51,10.43,11.3,2.07.57,2.65.35,2.81.17.49-.55-.42-2.78-1.48-5.37-.83-2-1.86-4.58-2.77-7.53l-.11-.38c-3-9.72-6.35-20.74-13.46-23.74-6.48-2.73-25.49-.88-29.44-.45.91,1.69,3.56,6.25,6.25,7.52a3,3,0,0,0,2.47.27,2.43,2.43,0,0,0,1.16-1.41l.47-1.7.49,1.68c.89,3.05,2.61,7.89,3.68,8.75a.54.54,0,0,0,.5.14c.75-.17,1.67-1.61,2.08-2.48l.66-1.42.28,1.54c0,.07,1.38,7.23,5.43,10.39.88.68,1.57.94,1.95.72.72-.41.8-2.47.63-3.81l1-.14c.43,2.59,2,9.59,4.14,10.91.5.31.72.19.79.15.81-.47,1.12-3.15,1.08-4.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.83,266.61s-2.64,2.45-5.65,1.32c-2.55-1-3.46-8.17-3.46-8.17s-1,4.44-2.75,2.75a54.49,54.49,0,0,1-4.29-5.05,1.86,1.86,0,0,1-2.22,2.26c-2.64-.3-6.37-4.1-6.37-4.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.83,268.73a5.28,5.28,0,0,1-1.82-.33c-1.94-.73-3-4.28-3.45-6.6a2.79,2.79,0,0,1-1.43,1.54,1.51,1.51,0,0,1-1.51-.47,44.89,44.89,0,0,1-3.56-4.1,2.07,2.07,0,0,1-.48.83,2.46,2.46,0,0,1-2.18.62c-2.78-.32-6.51-4.09-6.66-4.25a.5.5,0,1,1,.71-.7s3.64,3.68,6.06,4a1.51,1.51,0,0,0,1.34-.31,1.81,1.81,0,0,0,.33-1.37l-.3-2,1.2,1.58a52.53,52.53,0,0,0,4.24,5c.31.3.47.25.52.23.58-.18,1.17-1.73,1.39-2.73l.62-2.82.36,2.87c.25,1.92,1.28,7.06,3.15,7.76,2.67,1,5.1-1.2,5.13-1.22a.5.5,0,0,1,.68.74A7.08,7.08,0,0,1,392.83,268.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.87,207.31a4.26,4.26,0,0,1-1.52-.28,4.36,4.36,0,0,1-2.55-5.61,4.29,4.29,0,0,1,2.27-2.44,4.36,4.36,0,1,1,1.8,8.33Zm0-7.72a3.35,3.35,0,1,0,3.06,2,3.38,3.38,0,0,0-1.88-1.76A3.5,3.5,0,0,0,381.88,199.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.21,208a6,6,0,0,1-5.59-8.07h0a6,6,0,1,1,5.59,8.07Zm-4.65-7.72a5,5,0,1,0,6.39-2.91,5,5,0,0,0-6.39,2.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.27,222a10.29,10.29,0,0,1-3.67-.67,10.48,10.48,0,0,1-6.12-13.48h0A10.47,10.47,0,1,1,411.27,222Zm-8.86-13.8a9.47,9.47,0,1,0,12.19-5.54,9.5,9.5,0,0,0-12.19,5.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.06,227a7.09,7.09,0,0,1-6.46-4.16,7.1,7.1,0,0,1,8.95-9.58,7.09,7.09,0,0,1,4.15,9.14,7.1,7.1,0,0,1-6.64,4.6Zm0-13.19a6.09,6.09,0,0,0-2.15,11.8,6.11,6.11,0,0,0,7.85-3.56,6.1,6.1,0,0,0-5.7-8.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "224.45 121.83 221.82 125.44 223.3 129.65 219.06 128.26 215.51 130.97 215.52 126.51 211.85 123.97 216.1 122.6 217.37 118.33 219.99 121.94 224.45 121.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,132v-5.21l-4.28-3,4.95-1.6,1.5-5,3.05,4.22,5.21-.12-3.07,4.21,1.73,4.92-5-1.62Zm-2-7.84,3.05,2.1V130L219,127.7l3.53,1.15-1.23-3.49,2.19-3-3.71.09-2.18-3L216.5,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.97 70.88 301.89 72.7 301.09 77.08 298.1 73.77 293.68 74.36 295.9 70.5 293.98 66.47 298.34 67.39 301.57 64.32 302.04 68.75 305.97 70.88",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.39,78.17,297.9,74.3l-5.16.69,2.6-4.52-2.25-4.7,5.1,1.08L302,63.26l.55,5.18,4.58,2.48-4.75,2.13Zm-3.1-4.93L300.78,76l.67-3.65,3.39-1.52-3.26-1.76-.4-3.69-2.69,2.56-3.63-.77,1.6,3.35-1.85,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.81 124.34 425.74 126.16 424.94 130.54 421.95 127.23 417.52 127.82 419.75 123.96 417.82 119.93 422.19 120.85 425.42 117.78 425.89 122.21 429.81 124.34",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.24,131.63l-3.49-3.87-5.16.69,2.59-4.52-2.24-4.7,5.09,1.08,3.78-3.59.55,5.18,4.58,2.48-4.75,2.13Zm-3.1-4.93,2.49,2.76.67-3.65,3.38-1.52-3.26-1.76-.39-3.69-2.69,2.56-3.63-.77,1.6,3.35-1.85,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.65 58.22 198.57 60.05 197.77 64.43 194.78 61.12 190.36 61.71 192.58 57.84 190.66 53.82 195.02 54.74 198.25 51.67 198.72 56.1 202.65 58.22",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,65.52l-3.5-3.87-5.16.69,2.6-4.52-2.25-4.7,5.1,1.08,3.77-3.59.55,5.18,4.59,2.48L199,60.39ZM195,60.59l2.49,2.75.67-3.64,3.39-1.52-3.26-1.76-.4-3.69-2.69,2.55-3.62-.76,1.6,3.34-1.85,3.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.06 218.53 322.99 220.35 322.18 224.74 319.19 221.43 314.77 222.01 317 218.15 315.07 214.13 319.44 215.05 322.67 211.97 323.14 216.41 327.06 218.53",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.49,225.82,319,222l-5.17.68,2.6-4.51-2.25-4.7,5.1,1.07,3.78-3.59.55,5.18,4.58,2.48-4.76,2.13Zm-3.1-4.92,2.48,2.75.68-3.65,3.38-1.51-3.26-1.77-.39-3.69-2.69,2.56-3.63-.77,1.6,3.35-1.85,3.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.61 189.14 353.54 190.96 352.74 195.35 349.75 192.04 345.32 192.63 347.55 188.76 345.62 184.74 349.99 185.66 353.22 182.59 353.69 187.02 357.61 189.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,196.44l-3.49-3.87-5.16.69,2.59-4.52-2.24-4.7,5.09,1.07,3.78-3.59.55,5.19,4.58,2.48L354,191.31Zm-3.1-4.93,2.49,2.75.67-3.65,3.38-1.51-3.26-1.77-.39-3.68-2.69,2.55-3.63-.76,1.6,3.34L346.26,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.07 215.55 237.85 221.12 240.05 227.75 233.45 225.46 227.82 229.59 227.96 222.61 222.28 218.53 228.97 216.51 231.1 209.85 235.09 215.59 242.07 215.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3,230.6l.15-7.74-6.28-4.52,7.41-2.24,2.35-7.37,4.42,6.35,7.74,0-4.68,6.17,2.43,7.35L233.53,226Zm-3.9-11.89,5.06,3.64-.12,6.24,5-3.69,5.89,2L237.3,221l3.76-5-6.23,0L231.27,211l-1.9,5.94Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.31,285.09s6.72,6.72,6,8-6.47-5.72-18.66,3.49-4.23,21.9,1,24.88,0,5-.25,12.45,4.23,15.43,14.69,16.67,15.68-6,20.15-9.21,10.21,2,22.65,3,11.45-6.72,20.16-10.7,19.91-3.73,21.65-11.2-5.23-11.45-2-16.92,8.21-12.94,5.47-18.92-6.47-2.24-9-7,3-5.48-1.24-10.95-11.45-3.74-11.45-3.74,3.24,13.69-6.47,20.41-24.39,7.47-31.35,2.74-12.94-9.71-12.94-9.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43,351.18A20.78,20.78,0,0,1,83,351c-10.8-1.29-15.38-9.56-15.13-17.19a18.22,18.22,0,0,1,1.76-7c1-2.46,1.48-3.48-1.25-5a17.46,17.46,0,0,1-7.65-12.92c-.22-3.4.75-8.39,6.6-12.8,9.38-7.09,15.17-4.76,17.65-3.77a6.53,6.53,0,0,0,.88.32c-.13-.93-3.07-4.42-5.89-7.25l-.56-.55,19.42-7.09.23.19c0,.05,6,5,12.9,9.67,6.4,4.35,20.92,4.1,30.79-2.73,9.3-6.44,6.3-19.75,6.27-19.88l-.12-.49.49-.11c.07,0,7.58-1.76,12,3.91,2.49,3.22,1.79,5.05,1.19,6.66a4.45,4.45,0,0,0,.1,4.36,4.77,4.77,0,0,0,3.76,2.69c1.71.43,3.65.91,5.21,4.31,2.64,5.76-1.46,12.61-4.75,18.12l-.75,1.25c-1.54,2.6-.56,4.87.57,7.5s2.36,5.5,1.48,9.28c-1.25,5.35-7.06,7-13.2,8.64a56.91,56.91,0,0,0-8.73,2.9,20.36,20.36,0,0,0-6.83,5.36c-2.89,3.1-5.61,6-13.58,5.39a59.37,59.37,0,0,1-13-2.68c-4.21-1.26-7-2.08-9.33-.4-.9.64-1.84,1.47-2.83,2.34C97,347.28,92.53,351.18,85.43,351.18Zm-5.92-59c-2.84,0-6.65,1-11.59,4.76-4.35,3.28-6.49,7.41-6.2,11.93A16.36,16.36,0,0,0,68.86,321c3.51,2,2.74,3.81,1.68,6.3a17,17,0,0,0-1.68,6.59c-.23,7.17,4.08,14.95,14.25,16.16,8.1,1,13-3.29,16.9-6.72,1-.88,2-1.72,2.9-2.39,2.73-2,5.87-1,10.21.25a58.19,58.19,0,0,0,12.77,2.64c7.48.6,9.93-2,12.76-5.08a21.8,21.8,0,0,1,7.15-5.58,59.68,59.68,0,0,1,8.88-3c6.11-1.68,11.38-3.13,12.49-7.89.81-3.46-.33-6.11-1.42-8.66-1.19-2.76-2.31-5.37-.51-8.41L166,304c3.17-5.3,7.12-11.9,4.7-17.19-1.36-3-2.9-3.34-4.54-3.75a5.73,5.73,0,0,1-4.41-3.19,5.47,5.47,0,0,1-.15-5.18c.59-1.57,1.1-2.92-1.05-5.7-3.37-4.36-8.83-3.89-10.46-3.64.47,2.6,2,14.33-6.77,20.42-9.49,6.57-24.4,7.84-31.93,2.74-6.16-4.18-11.6-8.61-12.75-9.55l-17.42,6.35c3.05,3.1,6.24,6.79,5.5,8-.4.68-1.16.37-2.12,0A12.84,12.84,0,0,0,79.51,292.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.55,301s-27.23,11.16-34.82,18.3-3.79,11.61-2.9,12.95,10,37.27,12.28,42.62,2.68,8.93,10,11.61l-8,19.19s-32.36-6.69-40.4,4.24-4.24,23,3.35,28.35S123,458.35,123,458.35s83-18.52,96.42-22.54,19-18.08,15.84-24.1-11.82-7.81-21.2-7.81-29.23.44-29.23.44L179,378.23s8.71-68.07,7.14-74.54-7.81-6.92-15.62-8.26S148,293.2,148,293.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,458.87l-.12,0c-2.35-.6-57.53-14.82-65.11-20.17A19.28,19.28,0,0,1,50,426c-.64-3.92-.41-9.94,4.32-16.37,7.73-10.53,36.55-5.29,40.49-4.52l7.68-18.34c-6.19-2.38-7.39-5.47-9-9.7-.25-.64-.5-1.3-.79-2-1.24-3-4.52-15-7.42-25.66-2.17-8-4.42-16.23-4.82-16.89l-.15-.23c-1.08-1.55-4.37-6.29,3.13-13.35s33.86-17.95,35-18.4l.06,0L148,292.69H148c.15,0,14.85.91,22.6,2.24l2,.33c7,1.15,12.55,2.06,14.06,8.3,1.55,6.43-6.63,70.81-7.12,74.64l5.69,25.62c2.9-.06,20.31-.43,28.84-.43,11.59,0,18.87,2.72,21.65,8.08,1.39,2.69,1.16,6.79-.61,11a24.67,24.67,0,0,1-15.54,13.83c-13.25,4-95.62,22.37-96.45,22.55Zm-47.9-54.7c-8.16,0-16.5,1.31-20,6.05-4.52,6.15-4.74,11.89-4.13,15.62a18.32,18.32,0,0,0,7.37,12c7.26,5.13,61.76,19.23,64.66,20,3.57-.8,83.28-18.61,96.27-22.51a23.68,23.68,0,0,0,14.9-13.26c1.66-3.92,1.9-7.71.64-10.13-2.59-5-9.58-7.54-20.76-7.54-9.26,0-29,.44-29.22.44h-.41l-5.91-26.6v-.08c.08-.68,8.67-68.05,7.15-74.36-1.35-5.6-6.34-6.42-13.25-7.56l-2-.33c-7.4-1.26-21.22-2.14-22.41-2.22l-29.35,7.78c-1,.43-27.31,11.3-34.63,18.19-6.88,6.48-4.06,10.54-3,12.06l.17.25c.41.61,1.82,5.7,5,17.18,2.89,10.61,6.16,22.63,7.37,25.53.29.7.55,1.37.8,2,1.66,4.25,2.76,7.06,8.95,9.31l.5.18-8.4,20.06-.4-.09A114.53,114.53,0,0,0,75.11,404.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.53,416.74l3,8.71s16.17-5.73,24.88-10.46A112,112,0,0,0,185,404.34h-.11L179,378.23s8.71-68.07,7.14-74.54-7.81-6.92-15.62-8.26S148,293.2,148,293.2L118.55,301s-27.23,11.16-34.82,18.3-3.79,11.61-2.9,12.95,10,37.27,12.28,42.62,2.68,8.93,10,11.61l-8,19.19S99,410.52,108.68,414s30.11,11.45,30.11,11.45Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.11,426.11l-.5-.2c-.2-.08-20.51-8-30.1-11.44S94.89,406.2,94.73,406l-.19-.23,7.95-19c-6.19-2.38-7.39-5.47-9-9.7-.25-.64-.5-1.3-.79-2-1.24-3-4.52-15-7.42-25.66-2.17-8-4.42-16.23-4.82-16.89l-.15-.23c-1.08-1.55-4.37-6.29,3.13-13.35s33.86-17.95,35-18.4l29.6-7.86H148c.15,0,14.85.91,22.6,2.24l2,.33c7,1.15,12.55,2.06,14.06,8.3,1.55,6.43-6.63,70.81-7.12,74.64l5.7,25.63,1.15,0-1.12.91a113.09,113.09,0,0,1-15.63,10.7c-8.65,4.7-24.8,10.43-25,10.49l-.47.17-2.66-7.75Zm2.4-11,3.31,9.68c2.74-1,16.6-6.05,24.34-10.25a110.28,110.28,0,0,0,15.14-10.34l-5.77-26v-.08c.08-.68,8.67-68.05,7.15-74.36-1.35-5.6-6.34-6.42-13.25-7.56l-2-.33c-7.4-1.26-21.22-2.14-22.41-2.22l-29.38,7.79c-.21.09-27.17,11.19-34.6,18.18-6.88,6.48-4.06,10.54-3,12.06l.17.25c.41.61,1.82,5.7,4.94,17.18,2.89,10.6,6.17,22.63,7.38,25.53.29.7.55,1.37.8,2,1.66,4.25,2.76,7.06,8.95,9.31l.5.18L95.7,405.59c.88,1,4.87,5,13.15,7.94,8.76,3.14,26.43,10,29.62,11.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.88,382.34h-.11c-.73-.16-18-4-26.15-10.16a.5.5,0,1,1,.6-.79c7.95,6,25.59,9.94,25.77,10a.49.49,0,0,1,.38.59A.5.5,0,0,1,151.88,382.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.34,383.05h-.09A118.75,118.75,0,0,1,128.4,379a.5.5,0,0,1,.34-.94,118.82,118.82,0,0,0,13.7,4,.48.48,0,0,1,.39.58A.49.49,0,0,1,142.34,383.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.22,294.54s-5.36-.23-5.8,13.84,5.58,23.43,8,22.54,6-8.48,8.48-8.71,5.58,1.56,5.58,1.56-8-27.89-10.71-30.35S119.22,294.54,119.22,294.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.11,331.47a2.54,2.54,0,0,1-1.47-.56c-2.93-2.12-7.1-10.76-6.72-22.55.26-8.19,2.2-11.67,3.78-13.14a4.16,4.16,0,0,1,2.28-1.17,5.86,5.86,0,0,1,3.53-2,3.46,3.46,0,0,1,2.63,1c2.7,2.48,10,27.72,10.85,30.59l.34,1.18-1.07-.61s-3-1.7-5.28-1.5c-1.08.1-2.72,2.32-4.16,4.27s-2.9,3.94-4.2,4.41A1.52,1.52,0,0,1,121.11,331.47ZM119.21,295c-.11,0-4.87.17-5.29,13.35-.37,11.43,3.55,19.71,6.31,21.71.43.31.8.44,1,.35,1-.37,2.4-2.25,3.74-4.06,1.72-2.33,3.34-4.54,4.87-4.68a10.42,10.42,0,0,1,4.82,1.11c-2.45-8.4-8.23-27.18-10.25-29a2.41,2.41,0,0,0-1.88-.72,5.11,5.11,0,0,0-3,1.78l-.16.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.41,323.1s7.15-6.24,8.93-5.57,10.27,9.15,10.71,6.24-4.68-29.68-8-32.58-6.47.22-6.47.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,324.88c-1.37,0-3.71-1.81-7-4.46a23.64,23.64,0,0,0-3.26-2.43c-.93-.33-5.1,2.58-8.43,5.49l-1,.92,5.38-33.23.11-.11s3.5-3.42,7.16-.25c3.49,3,8.68,29.92,8.2,33a1.14,1.14,0,0,1-.7.95A1.25,1.25,0,0,1,157.4,324.88ZM147.08,317a1.23,1.23,0,0,1,.44.07,19.5,19.5,0,0,1,3.54,2.58c1.95,1.59,5.59,4.55,6.43,4.22,0,0,.07-.14.07-.16.37-2.44-4.65-29.35-7.87-32.13a4.13,4.13,0,0,0-5.68.09l-4.88,30.18C141.29,320,145.2,317,147.08,317Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.23,290.74s-4.91,26.56-7.82,32.36-8-.66-12-10.48-7.14-18.08-7.14-18.08Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.75,325.8h-.11c-4.06-.16-8.16-9.14-9.74-13-4-9.71-7.12-18-7.15-18.09l-.22-.58,28.31-4-.12.68c-.2,1.09-5,26.7-7.86,32.5C138,325,137,325.8,135.75,325.8ZM119.91,295c.78,2.05,3.55,9.25,6.92,17.48,3.08,7.54,6.47,12.28,8.85,12.37.84,0,1.64-.61,2.29-1.92,2.58-5.16,6.84-27.35,7.64-31.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.75 297.73 125.26 307.73 119.22 294.54 140.75 297.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,308.47l-6.66-14.56,23.76,3.52Zm-5-13.3L125.47,307l13.9-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.73,226.61s1.24-4.48,4.23-5a31.72,31.72,0,0,1,4.72-.5s-6.72-8.21,1.25-11.44,14.93-2,25.13,4.72,0,14.94-.49,16.43-12.45.5-20.66,3.73S101,241,101,241,96.24,236.07,98.73,226.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.93,241.73l-.33-.34c-.2-.21-4.89-5.29-2.36-14.91h0c.06-.2,1.37-4.8,4.63-5.34,1.73-.29,3-.41,3.86-.47-1-1.41-2.75-4.53-2-7.38.46-1.8,1.82-3.16,4-4.07,8.17-3.31,15.34-2,25.6,4.78,2.74,1.81,4.31,3.91,4.66,6.25.59,3.93-2.42,7.57-4,9.52A8.19,8.19,0,0,0,134,231c-.31.92-2,1.09-6.19,1.42s-10.13.8-14.76,2.62c-8,3.16-11.76,6.35-11.8,6.38Zm-1.72-15c-2,7.66.87,12.32,1.83,13.6a48.15,48.15,0,0,1,11.69-6.23c4.76-1.88,10.7-2.35,15-2.69,2.35-.19,5-.4,5.34-.78a6.15,6.15,0,0,1,1.09-1.51c1.62-2,4.34-5.24,3.81-8.74-.3-2-1.72-3.91-4.22-5.56-9.94-6.54-16.86-7.86-24.67-4.68a5.23,5.23,0,0,0-3.45,3.38c-.83,3.28,2.37,7.25,2.4,7.29l.67.81h-1.06a32.57,32.57,0,0,0-4.64.49C100.43,222.56,99.24,226.61,99.21,226.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.14,228.32c7.32-.06,14.23,2.17,18.21,7.57,4.93,6.7,6,15.72,10.94,22.57a26.11,26.11,0,0,1,4.22,17.75c-1.11,8.43-3.33,16.64-13.76,21.52s-28.61-3.85-34.6-7.18-10.87-15.89-14-27.43c-2.08-7.73-2.53-17.06,2.67-23.72C100.83,231.71,111.71,228.39,121.14,228.32Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,229.32c7.65,0,13.74,2.54,17.14,7.16,2.39,3.25,3.82,7,5.33,11s3,8,5.61,11.56a25.19,25.19,0,0,1,4,17c-1,7.85-2.91,15.93-13.19,20.74a16.44,16.44,0,0,1-7,1.36c-10.86,0-24.15-7.09-26.71-8.51-4.69-2.6-9.61-12.37-13.49-26.81C91.67,257.4,90,247.18,95.62,240c6.08-7.79,17.17-10.63,25.52-10.69h.26m0-1h-.26c-9.43.07-20.31,3.39-26.3,11.08-5.2,6.66-4.75,16-2.67,23.72,3.11,11.54,8,24.1,14,27.43,4.73,2.63,17.07,8.63,27.19,8.63a17.51,17.51,0,0,0,7.41-1.45c10.43-4.88,12.65-13.09,13.76-21.52a26.11,26.11,0,0,0-4.22-17.75c-5-6.85-6-15.87-10.94-22.57-3.93-5.34-10.72-7.57-17.95-7.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.65,267a.5.5,0,0,1-.08-1s2.61-.43,3.38-2.56a2.43,2.43,0,0,0-.17-2.32,2.47,2.47,0,0,0-2-1c-1.92,0-4.91-3.67-5.49-4.4a.5.5,0,1,1,.78-.62c1.23,1.55,3.6,4,4.71,4a3.51,3.51,0,0,1,2.84,1.43,3.43,3.43,0,0,1,.29,3.23c-1,2.69-4,3.19-4.16,3.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,277c-.43,0-.87,0-1.33-.07a.52.52,0,0,1-.45-.55.51.51,0,0,1,.55-.45c8.19.84,11.77-6.71,11.92-7a.49.49,0,0,1,.66-.24.5.5,0,0,1,.25.66C143.61,269.4,140,277,132.05,277Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.69,266.73a.45.45,0,0,1-.16,0,.51.51,0,0,1-.31-.64c0-.06,2.44-6.76,9.36-6.55a.5.5,0,0,1,.48.52.48.48,0,0,1-.51.48c-6.22-.22-8.3,5.63-8.39,5.88A.49.49,0,0,1,113.69,266.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43,251.86a.54.54,0,0,1-.22-.05.5.5,0,0,1-.23-.67c0-.06,2.71-5.27,8.17-3.13a.5.5,0,0,1,.29.65.49.49,0,0,1-.65.28c-4.6-1.8-6.82,2.47-6.91,2.65A.51.51,0,0,1,135.43,251.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,251.44c1.4,2.25,5.71,9.88,3,14.64a10.54,10.54,0,0,1-9.56,5.65,13.38,13.38,0,0,1-3.69-.53c-3.59-1-6.74-6.55-7.59-8.14,3.09-5.79,14.78-10.47,17.84-11.62m.4-1.21s-16,5.52-19.36,12.84c0,0,3.77,7.76,8.43,9.09a14.32,14.32,0,0,0,4,.57,11.57,11.57,0,0,0,10.42-6.15c3.55-6.22-3.46-16.35-3.46-16.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.39,237.74c1.15,2.35,4.47,10,1.62,14.38a9.7,9.7,0,0,1-8.36,4.79,11.73,11.73,0,0,1-4.2-.81c-2.91-1.13-5.43-6.12-6.36-8.44,3.26-5.34,14.27-9,17.3-9.92m.51-1.2s-15.27,4.18-18.92,11c0,0,2.9,7.81,7.11,9.45a12.67,12.67,0,0,0,4.56.88,10.66,10.66,0,0,0,9.19-5.25c3.77-5.76-1.94-16.12-1.94-16.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,250.73a.45.45,0,0,1-.34-.14.49.49,0,0,1,0-.7c.13-.13,3-3.1,6-2.81a.5.5,0,0,1-.09,1c-2.5-.25-5.15,2.47-5.18,2.5A.48.48,0,0,1,122.4,250.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.07,253.36l-.17,0a.5.5,0,0,1-.29-.65c0-.1.93-2.47,2.82-3.12a3.46,3.46,0,0,1,3,.49.5.5,0,1,1-.53.85,2.47,2.47,0,0,0-2.18-.4c-1.45.5-2.21,2.51-2.22,2.53A.5.5,0,0,1,124.07,253.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8,272.68a.52.52,0,0,1-.33-.12.5.5,0,0,1,0-.71l7.39-8.35a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7l-7.39,8.35A.48.48,0,0,1,95.8,272.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,241.79a.54.54,0,0,1-.37-.16.51.51,0,0,1,0-.71l5.05-4.74a.5.5,0,0,1,.71,0,.5.5,0,0,1,0,.71l-5.05,4.74A.51.51,0,0,1,141.85,241.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,260.89h-.07a1,1,0,0,1-.93-1.06c0-.33.61-8.19,8-11a1,1,0,0,1,.71,1.87c-6.21,2.36-6.73,9-6.75,9.27A1,1,0,0,1,108,260.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,243a1,1,0,0,1-.64-.23c-3.59-3-8.35-.47-8.55-.37a1,1,0,0,1-1.36-.4,1,1,0,0,1,.41-1.35c.24-.14,6.13-3.27,10.77.58A1,1,0,0,1,139,243Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7,232.08a13.35,13.35,0,0,1,1.5,13.44,35,35,0,0,1-9,12.69s1.74,5,1.49,7.47a91.07,91.07,0,0,1-2,9l16.42,19.16S98,294.8,87,290.32s-20.91-23.4-15.68-37.08,19.16-21.16,19.16-21.16a9.56,9.56,0,0,1,4.73-8C100.22,220.89,104,225.12,103.7,232.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,294.39c-4.93,0-14.25-.48-21.91-3.61-11.47-4.69-21.26-23.82-16-37.72C75.72,240.4,88.05,232.92,90,231.79a10.16,10.16,0,0,1,5-8.09c2-1.33,4.08-1.54,5.74-.61,2.31,1.31,3.61,4.6,3.5,8.83a14,14,0,0,1,1.45,13.79,35.59,35.59,0,0,1-8.84,12.66c.39,1.17,1.63,5.14,1.41,7.36a84.91,84.91,0,0,1-1.94,8.78l16.9,19.72-1,.07S110.85,294.39,108.75,294.39ZM98.5,223.52a5.58,5.58,0,0,0-3,1,9.11,9.11,0,0,0-4.5,7.52l0,.31-.28.15c-.14.08-13.84,7.55-18.93,20.9-5,13.17,4.56,32,15.4,36.43,9,3.7,20.48,3.62,23.9,3.5L95.19,274.76l.07-.25c0-.07,1.73-6.46,2-8.88s-1.45-7.2-1.47-7.25l-.11-.33.27-.22a34.9,34.9,0,0,0,8.81-12.5c3.08-7.57-1.22-12.7-1.41-12.92l-.12-.15v-.19c.14-3.88-1-7-3-8.1A3.32,3.32,0,0,0,98.5,223.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.32,271.43a6.36,6.36,0,0,1,2.39,2.7c1.11,2.06,12.23,17.63,14.14,18.75s13.82,7.31,15.25,11.44c1.16,3.33-2.54,42.79-4,58a76.31,76.31,0,0,1-2.42,13c-1.51,5.42-3.65,12.23-5.31,13.9-2.86,2.86-9.93,2.89-15.26.63-8.87-3.76-10.33-13-9.85-16.68s24.31-57.2,24.79-58.95a12.08,12.08,0,0,0,.32-4.45c-.16-.48-10.33-6.2-14.78-9.69s-6-5.4-7-6.84-4.77-18.74-4.13-19.7l.63-.95s.16-2.23,1.43-2.38S98.32,271.43,98.32,271.43Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.16,391.92a21.82,21.82,0,0,1-8.26-1.66c-9.59-4.06-10.57-14-10.16-17.21.31-2.3,8.8-22,18.23-43.67,3.45-7.94,6.42-14.79,6.58-15.34a12.31,12.31,0,0,0,.34-4.08c-.39-.33-2.24-1.47-4-2.57-3.37-2.07-8-4.9-10.6-7-4.56-3.58-6.15-5.52-7.1-6.95-.61-.91-5.06-18.87-4.13-20.26l.57-.84c.06-.55.39-2.53,1.85-2.71s3.8,1.15,4.11,1.33a7,7,0,0,1,2.59,2.9c1.11,2.07,12.23,17.55,13.95,18.56l1,.55c3.6,2,13.16,7.31,14.5,11.15,1.13,3.27-2,37.86-4,58.19a76.65,76.65,0,0,1-2.44,13.06c-2.21,8-4,12.72-5.44,14.12C117,391.2,114.2,391.92,111.16,391.92ZM94.72,270.64h-.15c-.7.09-1,1.45-1,1.93v.13l-.71,1.06c-.33,1.22,3.19,17.74,4.13,19.15s2.43,3.22,6.89,6.71c2.58,2,7.16,4.85,10.5,6.91,4.05,2.49,4.33,2.7,4.44,3a12.1,12.1,0,0,1-.31,4.74c-.16.59-2.38,5.71-6.62,15.47-7.11,16.35-17.85,41.06-18.15,43.41-.39,3,.53,12.34,9.55,16.16,5.39,2.29,12.13,2.05,14.7-.53,1.24-1.23,3.08-6.09,5.19-13.67a75.91,75.91,0,0,0,2.4-12.9c3.31-33.94,4.82-55.54,4-57.76-1.21-3.49-10.86-8.85-14-10.61l-1-.56c-2-1.18-13.25-16.94-14.33-18.94a6.2,6.2,0,0,0-2.17-2.5h0A9.39,9.39,0,0,0,94.72,270.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,376c-14.68.89-23.3-5-27.74-9.63a54,54,0,0,0-2.47,6.75c-.48,3.65,1,12.92,9.85,16.68,5.33,2.26,12.4,2.23,15.26-.63C119.93,387.58,122,381.29,123.45,376Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.16,391.92a21.82,21.82,0,0,1-8.26-1.66c-9.59-4.06-10.57-14-10.16-17.21.06-.44.38-1.63,2.5-6.87l.29-.72.54.56c4.59,4.8,13.07,10.35,27.35,9.48l.71,0-.2.68c-2.12,7.53-3.88,12-5.23,13.38C117,391.2,114.2,391.92,111.16,391.92ZM95.88,367.26a42.75,42.75,0,0,0-2.14,5.92c-.39,3,.53,12.34,9.55,16.16,5.39,2.29,12.13,2.05,14.7-.53,1.16-1.15,2.85-5.5,4.79-12.27C109.07,377.18,100.65,372,95.88,367.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15,291.05a.48.48,0,0,1-.42-.23l-3.13-4.74a44.32,44.32,0,0,1-6-15,.5.5,0,0,1,1-.15,43.78,43.78,0,0,0,5.81,14.6l3.12,4.73a.5.5,0,0,1-.14.7A.53.53,0,0,1,106.15,291.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.35,293.23a.5.5,0,0,1-.41-.22c-.17-.24-4.13-6.07-5.56-10s-3.26-12-3.33-12.3a.48.48,0,0,1,.37-.59.49.49,0,0,1,.6.37c0,.09,1.91,8.36,3.3,12.18s5.41,9.69,5.45,9.75a.5.5,0,0,1-.14.69A.47.47,0,0,1,102.35,293.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27,294.65a.51.51,0,0,1-.35-.13c-.13-.13-3.24-3.07-3.93-5.64s-3.29-15.68-3.4-16.24a.5.5,0,0,1,.39-.59.49.49,0,0,1,.59.39c0,.14,2.73,13.76,3.39,16.18s3.62,5.14,3.65,5.17a.5.5,0,0,1-.34.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,450.11s-9.5,2.55-14.13.93-22.94-7.88-32.68-6-8.8,14.84.93,18.54,28,2.55,34.07,1.63,15.52-2.78,15.52-2.78S104.32,452.89,105,450.11Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,466.62c-6.91,0-14.45-.62-19.64-2.6a11.93,11.93,0,0,1-8.06-11.84c.35-4,3-6.86,7.22-7.66,8.82-1.68,24.42,3.07,32.93,6.05,4.44,1.55,13.75-.91,13.84-.94l.83-.22-.21.82c-.54,2.14,2.47,9.36,3.68,12l.26.57-.62.13c-.1,0-9.58,1.86-15.55,2.78A106,106,0,0,1,78.59,466.62ZM62.33,445.17a21.11,21.11,0,0,0-4,.34,7.39,7.39,0,0,0-6.42,6.76c-.33,3.72,1.86,8.69,7.43,10.82,9.7,3.69,28.18,2.46,33.81,1.59,5.06-.78,12.67-2.23,14.88-2.65-.91-2-3.58-8.24-3.56-11.26-2.31.56-9.69,2.16-13.73.74C83.49,449,71.13,445.17,62.33,445.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2,445c-9.73,1.86-8.8,14.84.93,18.54s28,2.55,34.07,1.63c1.71-.27,3.71-.61,5.68-1a57.54,57.54,0,0,1-11.25-1.82A13.35,13.35,0,0,0,92,455.91c1.16-3.32.06-4.38-.65-4.72a3.8,3.8,0,0,1-.51-.15C86.24,449.42,67.94,443.16,58.2,445Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,466.62c-6.91,0-14.45-.62-19.64-2.6a11.93,11.93,0,0,1-8.06-11.84c.35-4,3-6.86,7.22-7.66,8.82-1.68,24.42,3.07,32.93,6.05l.48.14c1,.45,2.27,1.69,1,5.36a15,15,0,0,1-3.81,6.09,60.71,60.71,0,0,0,10.22,1.56l4,.29-4,.71c-2,.35-4,.69-5.7.95A106,106,0,0,1,78.59,466.62ZM58.3,445.51a7.39,7.39,0,0,0-6.42,6.76c-.33,3.72,1.86,8.69,7.43,10.82,9.7,3.69,28.18,2.46,33.81,1.59l2-.32a54.7,54.7,0,0,1-7.67-1.48l-1-.31.88-.59a13.07,13.07,0,0,0,4.2-6.24c.76-2.17.63-3.62-.38-4.09a4.31,4.31,0,0,1-.47-.14c-8.41-2.94-23.82-7.64-32.41-6Zm-.1-.5h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,410.72l95.24,37.54a22.52,22.52,0,0,1-.69,9c-1.39,5.56-3.24,6.72-3.24,6.72L123,458.35s-38.16-9.86-43.72-11.94-19.93-5.1-25.49-10-6.72-17.15-2.09-23.17,7.65-7.65,12-8.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,464.53l-.17,0L123,458.85c-1.63-.42-38.32-9.91-43.84-12-1.5-.56-3.64-1.19-6.11-1.91-6.5-1.91-15.41-4.53-19.54-8.14-5.84-5.11-7-17.6-2.15-23.86s8.15-7.86,12.39-8.3a.49.49,0,0,1,.55.44.5.5,0,0,1-.44.55c-4.06.43-7,1.77-11.71,7.92-4.45,5.79-3.38,17.77,2,22.49,4,3.47,12.75,6.05,19.16,7.94,2.49.73,4.65,1.36,6.18,1.94,5.47,2.05,43.29,11.83,43.67,11.93l51,5.63c.4-.37,1.8-1.9,2.91-6.32a24,24,0,0,0,.73-8.56l-95-37.44a.5.5,0,0,1-.29-.65.51.51,0,0,1,.65-.28l95.5,37.64,0,.27a22.71,22.71,0,0,1-.7,9.26c-1.42,5.69-3.38,7-3.46,7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,450.11s9.5,2.55,14.14.93,22.94-7.88,32.67-6,8.81,14.84-.92,18.54-28,2.55-34.07,1.63-15.53-2.78-15.53-2.78S178.81,452.89,178.11,450.11Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.53,466.62a105.8,105.8,0,0,1-14.67-.95c-6-.92-15.46-2.76-15.55-2.78l-.63-.13.27-.57c1.2-2.6,4.21-9.82,3.68-12l-.21-.82.82.22c.1,0,9.41,2.49,13.84.94,8.52-3,24.12-7.73,32.94-6.05,4.17.8,6.87,3.66,7.22,7.66A11.93,11.93,0,0,1,224.18,464C219,466,211.45,466.62,204.53,466.62ZM175.12,462c2.21.42,9.83,1.87,14.89,2.65,5.63.87,24.11,2.1,33.81-1.59,5.57-2.13,7.75-7.1,7.42-10.82a7.38,7.38,0,0,0-6.41-6.76c-8.59-1.64-24,3.06-32.42,6-4,1.42-11.41-.18-13.73-.74C178.7,453.79,176,460,175.12,462Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.92,445c9.74,1.86,8.81,14.84-.92,18.54s-28,2.55-34.07,1.63c-1.71-.27-3.71-.61-5.69-1a57.54,57.54,0,0,0,11.25-1.82,13.3,13.3,0,0,1-4.4-6.49c-1.16-3.32-.07-4.38.65-4.72a4.28,4.28,0,0,0,.51-.15C196.88,449.42,215.19,443.16,224.92,445Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.53,466.62a105.8,105.8,0,0,1-14.67-.95c-1.72-.26-3.72-.6-5.71-.95l-4-.71,4-.29a60.73,60.73,0,0,0,10.21-1.56,15.07,15.07,0,0,1-3.8-6.09c-1.29-3.67,0-4.91.91-5.33l.55-.17c8.52-3,24.12-7.73,32.94-6.05h0c4.17.8,6.87,3.66,7.22,7.66A11.93,11.93,0,0,1,224.18,464C219,466,211.45,466.62,204.53,466.62ZM188,464.36l2,.32c5.63.87,24.11,2.1,33.81-1.59,5.57-2.13,7.75-7.1,7.42-10.82a7.38,7.38,0,0,0-6.41-6.76h0c-8.59-1.64-24,3.06-32.42,6l-.54.17c-.93.44-1.07,1.89-.31,4.06a13,13,0,0,0,4.21,6.24l.88.59-1,.31A55.11,55.11,0,0,1,188,464.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,409.09S172.45,423,158.08,428.56s-49.13,19.7-51.44,20.16-3.25,3.71-2.32,7.88,4.4,7.42,6,7.42,79-12,88.07-14.14,32.21-11.12,35.68-14.83,7-9.27,5.8-17.38-5.1-14.37-13.67-14.14a95.23,95.23,0,0,0-18.31,2.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.34,464.52c-1.88,0-5.52-3.35-6.51-7.81-.64-2.89-.43-5.43.58-7a3.29,3.29,0,0,1,2.13-1.5c1.4-.28,16.25-6.2,29.36-11.42,8.16-3.26,16.61-6.63,22-8.72,14.2-5.49,45.55-19.31,45.87-19.45a.5.5,0,1,1,.4.91c-.31.14-31.69,14-45.91,19.48-5.39,2.08-13.83,5.45-22,8.7-14.42,5.75-28,11.18-29.54,11.48a2.32,2.32,0,0,0-1.49,1.07c-.84,1.3-1,3.62-.43,6.21.88,4,4.21,7,5.53,7,2.13,0,79.4-12.15,87.95-14.13,8.91-2.05,32-11,35.44-14.68,4.72-5,6.58-10.59,5.66-17s-3.94-14-13.16-13.71A95.29,95.29,0,0,0,208,406.8a.5.5,0,1,1-.25-1A96.21,96.21,0,0,1,226.2,403c7.91-.19,12.79,4.83,14.18,14.57,1,6.7-1,12.52-5.92,17.79-3.6,3.84-26.7,12.85-35.94,15C189.56,452.44,112.29,464.52,110.34,464.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.61,446.6a15.32,15.32,0,0,1,2-7.82H107.32a7.6,7.6,0,0,0,0,15.19H172.4A15.48,15.48,0,0,1,170.61,446.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.24,454.47H107.32a8.1,8.1,0,0,1,0-16.19h66.2l-.45.76a15.56,15.56,0,0,0-.23,14.69Zm-65.92-15.19a7.1,7.1,0,0,0,0,14.19h64.27a16.16,16.16,0,0,1-1.48-6.87,16.39,16.39,0,0,1,1.68-7.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,455.31H107.32a8.94,8.94,0,0,1,0-17.87h65.32a1.34,1.34,0,1,1,0,2.68H107.32a6.26,6.26,0,0,0,0,12.51H172.4a1.34,1.34,0,1,1,0,2.68Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.4,455.81H107.32a9.44,9.44,0,0,1,0-18.87h65.32a1.84,1.84,0,1,1,0,3.68H107.32a5.76,5.76,0,0,0,0,11.51H172.4a1.84,1.84,0,1,1,0,3.68Zm-65.08-17.87a8.44,8.44,0,0,0,0,16.87H172.4a.84.84,0,0,0,0-1.68H107.32a6.76,6.76,0,0,1,0-13.51h65.32a.84.84,0,1,0,0-1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.55,438.78a15.41,15.41,0,0,0-2,7.82,15.59,15.59,0,0,0,1.78,7.37h9.09a15.48,15.48,0,0,1-1.79-7.37,15.32,15.32,0,0,1,2-7.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.24,454.47H163l-.15-.26A16.09,16.09,0,0,1,161,446.6a15.91,15.91,0,0,1,2.1-8.08l.14-.24h10.25l-.45.76a15.56,15.56,0,0,0-.23,14.69Zm-9.63-1h8a16.16,16.16,0,0,1-1.48-6.87,16.39,16.39,0,0,1,1.68-7.32h-7.95a15.72,15.72,0,0,0-.23,14.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,464.32a15.41,15.41,0,0,1,2-7.82H109.17a7.6,7.6,0,1,0,0,15.19h65.07A15.44,15.44,0,0,1,172.46,464.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08,472.19H109.17a8.1,8.1,0,1,1,0-16.19h66.19l-.45.76a15.63,15.63,0,0,0-.23,14.69ZM109.17,457a7.1,7.1,0,1,0,0,14.19h64.26a16.79,16.79,0,0,1,.21-14.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,473H109.17a8.94,8.94,0,1,1,0-17.87h65.31a1.34,1.34,0,1,1,0,2.68H109.17a6.26,6.26,0,1,0,0,12.51h65.07a1.34,1.34,0,1,1,0,2.68Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.24,473.53H109.17a9.44,9.44,0,1,1,0-18.87h65.31a1.84,1.84,0,1,1,0,3.68H109.17a5.76,5.76,0,1,0,0,11.51h65.07a1.84,1.84,0,1,1,0,3.68Zm-65.07-17.87a8.44,8.44,0,1,0,0,16.87h65.07a.84.84,0,1,0,0-1.68H109.17a6.76,6.76,0,1,1,0-13.51h65.31a.84.84,0,1,0,0-1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4,456.5a16.07,16.07,0,0,0-.24,15.19h9.08a16.15,16.15,0,0,1,.24-15.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08,472.19H164.86l-.14-.26a16.57,16.57,0,0,1,.25-15.68l.14-.25h10.25l-.45.76a15.63,15.63,0,0,0-.23,14.69Zm-9.62-1h8a16.79,16.79,0,0,1,.21-14.19h-7.95a15.63,15.63,0,0,0-.23,14.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,298.56c4.24-.67,24.32,1.78,26.11,5.8s-2.23,27.9-4,37.72-18.08,54.23-19,56.91-5.58,3.12-19.64,2.23-64-2-64-2-3.57,8.48-5.36,10-6.25,5.36-6.25,5.36,0,4.91,1.56,5.36,2.24.67,1.57,2.67a3.79,3.79,0,0,1-2.46,2.46l-1.78.67c-1.79.67-2.46,0-2.46,0s-1.78-.22-2.23-1.12-3.57-7.81-2.68-10.26,9.82-19.2,10.94-20.54,19.13-4.05,19.13-4.05l56.08-10.9a2.38,2.38,0,0,1,.89-2.23l1.12-.67s7.59-35.49,9.37-42.41,6.47-14.5,6.47-14.5",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,426.57a2.23,2.23,0,0,1-1.23-.32c-.49-.08-2-.4-2.48-1.37,0-.08-3.74-7.8-2.7-10.66.9-2.48,9.86-19.29,11-20.69S98.75,390,103,389.31l55.63-10.82a2.62,2.62,0,0,1,1.16-2.25l.92-.56c.64-3,7.64-35.64,9.34-42.21,1.78-6.91,6.48-14.57,6.53-14.64a.5.5,0,0,1,.69-.17.51.51,0,0,1,.16.69c0,.08-4.67,7.61-6.41,14.37s-9.3,42-9.37,42.38l0,.22-1.3.78c-.81.48-.66,1.72-.65,1.73l.06.47-56.54,11c-8.68,1.31-18.09,3.12-18.85,3.89-1.08,1.29-10,18.06-10.85,20.38-.72,2,1.73,8,2.66,9.87.24.49,1.35.78,1.84.84l.17,0,.13.13h0s.53.4,1.92-.12l1.79-.67a3.29,3.29,0,0,0,2.15-2.14,2.14,2.14,0,0,0,.17-1.41c-.13-.26-.61-.41-1.39-.63-1.83-.53-1.93-5-1.93-5.84v-.23l.18-.15s4.46-3.79,6.24-5.35c1.4-1.22,4.25-7.53,5.23-9.86l.13-.32h.34c.5,0,50.16,1.13,64.07,2,13.72.87,18.37.41,19.14-1.89.15-.45.72-2,1.58-4.44,4.35-12.1,15.89-44.25,17.37-52.4,2.9-16,5.49-34.19,4.05-37.43-1.59-3.58-21.28-6.19-25.57-5.51a.5.5,0,1,1-.16-1c4.37-.69,24.71,1.73,26.65,6.09s-2.16,28-4,38c-1.49,8.23-13.06,40.43-17.41,52.56-.86,2.38-1.43,4-1.57,4.41-1,3-5.32,3.52-20.15,2.58-13.28-.85-59.27-1.9-63.69-2-.68,1.58-3.69,8.45-5.36,9.91s-5.23,4.49-6.08,5.21c0,1.88.45,4.43,1.2,4.65s1.66.47,2,1.13a2.74,2.74,0,0,1-.11,2.18,4.26,4.26,0,0,1-2.81,2.78l-1.73.66A4.68,4.68,0,0,1,79,426.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.73,404.71S74,411,72,412s-5.84,2.42-5.27,3.71A2.48,2.48,0,0,0,70,417.26c1.57-.57,5.71-1.86,5.71-1.86l5-12.4Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.08,417.93a3.06,3.06,0,0,1-2.78-2c-.67-1.5,1.85-2.66,4.28-3.77l1.23-.59c1.53-.76,4.48-5.36,5.49-7.07l.07-.12,4.36-2.49-5.62,14-.22.07s-4.15,1.29-5.68,1.84A3.12,3.12,0,0,1,69.08,417.93Zm9-12.85c-.61,1-3.86,6.36-5.84,7.35L71,413c-1.11.51-4,1.87-3.79,2.46a2,2,0,0,0,2.65,1.31c1.37-.5,4.61-1.52,5.5-1.79l4.37-10.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.83,386a.5.5,0,0,1-.49-.42c-.79-4.87-3.67-5.84-3.79-5.88a.5.5,0,1,1,.29-.95c.15,0,3.59,1.15,4.48,6.67a.49.49,0,0,1-.41.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,384.11a.5.5,0,0,1-.46-.3c-2.25-5.43-5.67-5.4-5.79-5.4a.52.52,0,0,1-.52-.48.5.5,0,0,1,.48-.52c.17,0,4.23-.08,6.75,6a.5.5,0,0,1-.27.66A.58.58,0,0,1,168.39,384.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,393.85c-1.12,1.34-10,18.08-10.94,20.54s2.23,9.37,2.68,10.26,2.23,1.12,2.23,1.12.67.67,2.46,0l1.78-.67a3.79,3.79,0,0,0,2.46-2.46c.67-2,0-2.23-1.57-2.67s-1.56-5.36-1.56-5.36,4.47-3.79,6.25-5.36,5.36-10,5.36-10,14.35.32,29.84.76a22.57,22.57,0,0,0-2.18-13.6l-17.68,3.43S85.07,392.51,84,393.85Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,426.57a2.23,2.23,0,0,1-1.23-.32c-.49-.08-2-.4-2.48-1.37,0-.08-3.74-7.8-2.7-10.66.9-2.48,9.86-19.29,11-20.69S98.75,390,103,389.31l18-3.51.17.34a23,23,0,0,1,2.23,13.9l-.06.44-.45,0c-14-.39-27.23-.69-29.49-.74-.68,1.58-3.69,8.45-5.36,9.91s-5.23,4.49-6.08,5.21c0,1.88.45,4.43,1.2,4.65s1.66.47,2,1.13a2.74,2.74,0,0,1-.11,2.18,4.26,4.26,0,0,1-2.81,2.78l-1.73.66A4.68,4.68,0,0,1,79,426.57Zm-.67-1.15s.53.4,1.92-.12l1.79-.67a3.29,3.29,0,0,0,2.15-2.14,2.14,2.14,0,0,0,.17-1.41c-.13-.26-.61-.41-1.39-.63-1.83-.53-1.93-5-1.93-5.84v-.23l.18-.15s4.46-3.79,6.24-5.35c1.4-1.22,4.25-7.53,5.23-9.86l.13-.32h.34c.14,0,14.25.32,29.4.74a22.12,22.12,0,0,0-2-12.52l-17.3,3.36c-8.68,1.31-18.08,3.12-18.85,3.89-1.09,1.32-10,18.06-10.85,20.38-.72,2,1.73,8,2.66,9.87.24.49,1.35.78,1.84.84l.17,0,.13.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.17,425.6a.49.49,0,0,1-.3-.1c-.31-.24-3.07-2.35-3.45-2.73-.56-.56-1.83-6.91-1.59-8a.5.5,0,0,1,.6-.38.49.49,0,0,1,.38.59c-.21.93,1,6.54,1.36,7.11.21.2,2.15,1.7,3.31,2.59a.5.5,0,0,1,.09.7A.51.51,0,0,1,82.17,425.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.93,426.27a.51.51,0,0,1-.39-.19,12.13,12.13,0,0,1-1.8-2.83c-.12-.61-1.7-9-1.7-9l1-.19s1.58,8.37,1.7,9a13.17,13.17,0,0,0,1.61,2.41.5.5,0,0,1-.09.7A.51.51,0,0,1,77.93,426.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,417.58H104.33v-1.69l2.31.12V401.06h-2.31V399.3h63.36a9.14,9.14,0,0,1,9.14,9.14h0A9.14,9.14,0,0,1,167.69,417.58Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.69,418.08H103.83v-2.72l2.31.12V401.56l-2.31,0V398.8h63.86a9.64,9.64,0,1,1,0,19.28Zm-62.86-1h62.86a8.64,8.64,0,1,0,0-17.28H104.83v.75h2.31v16l-2.31-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.17,408.44c0,4.14-3.89,7.48-8.7,7.48H106.64V401.06l47.83-.1C159.28,401,163.17,404.31,163.17,408.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,416.42H106.14V400.56l48.33-.1c5.07,0,9.2,3.58,9.2,8S159.54,416.42,154.47,416.42Zm-47.33-1h47.33c4.52,0,8.2-3.13,8.2-7s-3.68-7-8.2-7l-47.33.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.22,401.7v13.48a7.06,7.06,0,0,0,0-13.48Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,415.93V401l.69.28a7.56,7.56,0,0,1,0,14.41Zm1-13.45V414.4a6.47,6.47,0,0,0,0-11.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.1,438.34H99.47v-1.81l2.46.13v-16l-2.46,0v-1.86H167.1a9.76,9.76,0,0,1,9.75,9.76h0A9.76,9.76,0,0,1,167.1,438.34Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.09,438.84H99V436l2.46.13V421.2l-2.46,0v-2.86h68.12a10.26,10.26,0,0,1,0,20.52Zm-67.12-1h67.12a9.26,9.26,0,0,0,0-18.52H100v.87h2.46v17l-2.46-.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.27,428.58c0,4.41-4.16,8-9.29,8h-51V420.7l51-.11C158.11,420.59,162.27,424.17,162.27,428.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,437.06H101.43V420.2l51.55-.11c5.4,0,9.79,3.81,9.79,8.49S158.38,437.06,153,437.06Zm-50.55-1H153c4.85,0,8.79-3.35,8.79-7.48s-3.94-7.49-8.79-7.49l-50.55.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,421.38v14.39a7.54,7.54,0,0,0,0-14.39Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.49,436.52V420.64l.69.28a8,8,0,0,1,0,15.32Zm1-14.36V435a7,7,0,0,0,0-12.84Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.95a25fedda0b14944677afa495911f4d.svg";
export { ForwardRef as ReactComponent };